<template>
  <div class="fpaDetail">
    <div>
      <p class="icon-jujue closeBtn" @click="routerBack"></p>
    </div>
    <el-row class="btn" type="flex" justify="start" align="middle" v-if="canUpdate||nfcAdminSubmit||canMenuVpApprove||canScmVpApprove||canCfoVpApprove||canCeoApprove||canCgoApprove||formData.canAudit">
      <el-button v-if="canUpdate" type="primary" @click="fpaLtoCampaignSave">{{ $t('common.saveDraft') }}</el-button>
      <el-button v-if="canUpdate&&isOwner" type="primary" @click="onSelNfs">选择NFS</el-button>
      <!-- 新建且是nfc-admin角色且是创建的用户可以看到 -->
      <el-button v-if="canUpdate&&isOwner" type="primary" @click="fpaLtoCampaignSubmit">{{ $t('common.submit') }}</el-button>
      <!-- (this.formData.status == 'nfcApproved' || this.formData.status == 'reject')并且localStorage.getItem("ms_userId") == this.formData.createBy显示 -->
      <el-button v-if="nfcAdminSubmit" type="primary" @click="fpaNfcAdminSubmit">{{ $t('common.submit') }}</el-button>
      <!-- <el-button v-if="canMenuVpApprove" type="primary" @click="fpaLtoCampaignApprove('approving')">{{ $t('fpaManage.permanent.audit') }}</el-button> -->
      <el-button v-if="canMenuVpApprove" type="primary" @click="fpaLtoCampaignApprove('approving')">Approve</el-button>
      <el-button v-if="canMenuVpApprove" type="primary" @click="fpaLtoCampaignApprove('reject')">Reject</el-button>
      <!-- <el-button v-if="canScmVpApprove" type="primary" @click="fpaLtoCampaignApprove('approving')">{{ $t('fpaManage.permanent.audit') }}</el-button> -->
      <el-button v-if="canScmVpApprove" type="primary" @click="fpaLtoCampaignApprove('approving')">Approve</el-button>
      <el-button v-if="canScmVpApprove" type="primary" @click="fpaLtoCampaignApprove('reject')">Reject</el-button>
      <!-- <el-button v-if="canCfoVpApprove" type="primary" @click="fpaLtoCampaignApprove('approving')">{{ $t('fpaManage.permanent.audit') }}</el-button> -->
      <el-button v-if="canCfoVpApprove" type="primary" @click="fpaLtoCampaignApprove('approving')">Approve</el-button>
      <el-button v-if="canCfoVpApprove" type="primary" @click="fpaLtoCampaignApprove('reject')">Reject</el-button>
      <!-- <el-button v-if="canCeoApprove" type="primary" @click="fpaLtoCampaignApprove('approving')">{{ $t('fpaManage.permanent.audit') }}</el-button> -->
      <el-button v-if="canCeoApprove" type="primary" @click="fpaLtoCampaignApprove('approving')">Approve</el-button>
      <el-button v-if="canCeoApprove" type="primary" @click="fpaLtoCampaignApprove('reject')">Reject</el-button>

      <el-button v-if="canCgoApprove" type="primary" @click="fpaLtoCampaignApprove('approving')">Approve</el-button>
      <el-button v-if="canCgoApprove" type="primary" @click="fpaLtoCampaignApprove('reject')">Reject</el-button>

      <!-- <el-button v-if="formData.canAudit" type="primary" @click="fpaLtoCampaignApprove('approving')">{{ $t('fpaManage.permanent.audit') }}</el-button> -->
      <el-button v-if="formData.canAudit" type="primary" @click="fpaLtoCampaignApprove('approving')">Approve</el-button>
      <el-button v-if="formData.canAudit" type="primary" @click="fpaLtoCampaignApprove('reject')">Reject</el-button>

      <!-- <el-button v-if="canDownload" type="primary" @click="attachmentDownload">{{ $t('fpaManage.permanent.pdfDownload') }}</el-button> -->
      <!-- <el-button type="primary" @click="routerBack">{{ $t('common.close') }}</el-button> -->
    </el-row>
    <el-form :model="formData" ref="formData1" label-width="230px" label-position="left">
      <div class="view_content">
        <div class="fpaNo">
          <p>FPA NO:</p>
          <p>{{formData.fpaNo}}</p>
        </div>
        <div class="status">
          <p>Status:</p>
          <p>{{formData.queryStatus}}</p>
        </div>
        <div class="creator">
          <p>Creator:</p>
          <p>{{formData.createUser}}</p>
        </div>
        <div class="createDate">
          <p>Creation Date:</p>
          <p>{{formData.createDate}}</p>
        </div>
        <div class="approver">
          <p>Last Approver:</p>
          <p>{{formData.lastApprover}}</p>
        </div>
      </div>
      <div class="info_box_father">
        <div class="info_box">
          <!-- Basic Information -->
          <!-- :style="showAll?'width:60%':'width:100%'" -->
          <div class="info_box_lf">
            <!-- :style="showAll?'width:100%':'width:60%'" -->
            <div>
              <div class="info_box_title">
                <p class="line"></p>
                <p class="info_title">Basic Information</p>
              </div>
              <!-- Purpose of the Agreement -->
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item prop="purposeOfTheAgreement" style="width: 100%">
                    <p slot="label">
                      <span class="icon-fenlei element_icon"></span>
                      Purpose of the Agreement
                    </p>
                    <el-select v-model="formData.agreementPurpose" :disabled="!canUpdate||!isOwner" style="width: 100%;">
                      <el-option :key="index" v-for="(item,index) in agreementPurposeList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- Supplier -->
              <el-row :gutter="20" v-if="showAll">
                <el-col :span="24">
                  <el-form-item prop="ltoSupplier" style="width: 100%">
                    <p slot="label">
                      <span class="el-icon-user-solid element_icon"></span>
                      Supplier
                    </p>
                    <el-input disabled v-model="formData.ltoSupplier" style="width: 100%" :title="formData.ltoSupplier"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- Campaign Start Date Campaign End Date -->
              <el-row :gutter="20">
                <el-col :span="13">
                  <el-form-item prop="agreementStartDate" :rules="fpaRules.agreementStartDate" style="width: 100%;">
                    <p slot="label">
                      <span class="el-icon-date element_icon" style="font-size:24px!important"></span>
                      Campaign Start Date
                    </p>
                    <el-date-picker type="date" placeholder="选择日期" v-model="formData.agreementStartDate" value-format="yyyy-MM-dd" style="width: 100%;" :disabled="!canUpdate||!isOwner" :picker-options="AgreementPickerOptionsStart"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="Campaign End Date" label-width="140px" prop="agreementEndDate" :rules="fpaRules.agreementEndDate" style="width: 100%;">
                    <el-date-picker type="date" placeholder="选择日期" v-model="formData.agreementEndDate" value-format="yyyy-MM-dd" style="width: 100%;" :disabled="!canUpdate||!isOwner" :picker-options="AgreementPickerOptionsEnd"></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- Product or Commodity Purchased-->
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item prop="productOrCommodityPurchased" :rules="fpaRules.productOrCommodityPurchased" style="width:100%">
                    <p slot="label">
                      <span class="el-icon-notebook-2 element_icon"></span>
                      Product or Commodity Purchased
                    </p>
                    <el-input v-model="formData.productOrCommodityPurchased" style="width: 100%" :title="formData.productOrCommodityPurchased" :disabled="!canUpdate||!isOwner"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- 	删除Sales Start Date & Sales End Date字段信息 -->
              <!-- Sales Start Date Sales End Date -->
              <!-- <el-row :gutter="20">
                <el-col :span="13">
                  <el-form-item prop="salesStartDate" style="width: 100%;">
                    <p slot="label">
                      <span class="el-icon-date element_icon" style="font-size:24px!important"></span>
                      Sales Start Date
                    </p>
                    <el-date-picker type="date" placeholder="选择日期" v-model="formData.salesStartDate" value-format="yyyy-MM-dd" style="width: 100%;" :disabled="!canUpdate" :picker-options="SalesPickerOptionsStart"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="Sales End Date" label-width="140px" prop="salesEndDate" style="width: 100%;">
                    <el-date-picker type="date" placeholder="选择日期" v-model="formData.salesEndDate" value-format="yyyy-MM-dd" style="width: 100%;" :disabled="!canUpdate" :picker-options="SalesPickerOptionsEnd"></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row> -->
              <!-- Estimate Volume of Purchase -->
              <el-row :gutter="20" v-if="showAll">
                <el-col :span="24">
                  <el-form-item prop="estimateVolumeOfPurchase" style="width: 100%">
                    <p slot="label">
                      <span class="icon-shuliang element_icon"></span>
                      Estimate Volume of Purchase
                    </p>
                    <el-input v-model="formData.estimateVolumeOfPurchase" style="width: 100%" :disabled="!estimateVolumeOfPurchaseUpdate"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- SS反馈时间(H) SS反馈截至时间-->
              <el-row :gutter="20">
                <el-col :span="13">
                  <el-form-item prop="ssFeedbackHour" :rules="fpaRules.ssFeedbackHour" style="width: 100%;">
                    <p slot="label" class="required_p">
                      <span class="icon-fankui element_icon"></span>
                      SS Feedback Time(H)
                    </p>
                    <el-input :disabled="!canUpdate||!isOwner" v-model="formData.ssFeedbackHour" @change="changeSsFeedbackHour" style="width: 100%;"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="SS Feedback Deadline" label-width="140px" style="width: 100%;">
                    <el-input placeholder="" v-model="formData.ssFeedbackDeadline" :disabled="true" style="width: 100%;"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <!-- Notional  Value of Agreement -->
          <!-- v-if="showAll" -->
          <div class="info_box_rg">
            <div class="national_box">
              <div class="info_box_title">
                <p class="line"></p>
                <p class="info_title">Notional Value of Agreement</p>
              </div>
              <div class="price_box1">
                <span class="icon-huobi qian"></span>
                <p class="notional_qian">
                  {{formData.notionalValueOfAgreement}}
                </p>
              </div>
            </div>
            <div class="coverage_box">
              <div class="info_box_title" style="margin-top:10px">
                <p class="line" v-if="showAll||(!showAll&&nfsLists.length>0)"></p>
                <p class="info_title" v-if="showAll">Coverage</p>
                <p class="info_title" v-if="!showAll&&nfsLists.length>0">NFS</p>
              </div>
              <div class="coverage_table">
                <table class="table-d" v-if="showAll">
                  <tr>
                    <td class="title">#</td>
                    <td class="title">Coverage</td>
                    <td class="title">Percentage</td>
                  </tr>
                  <tr>
                    <td>1</td>
                    <td>Supplier Coverage</td>
                    <td>
                      <!--supplierCoverageTotal-->
                      <el-form-item label-width="0" prop="supplierCoverageTotal">
                        <el-input v-model="formData.supplierCoverageTotal" style="width: 100%" :disabled="!nfcAdminSubmit"></el-input>
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>McDonald's Coverage</td>
                    <td>
                      <!--mcdCoverageTotal-->
                      <el-form-item label-width="0" prop="mcdCoverageTotal">
                        <el-input v-model="formData.mcdCoverageTotal" style="width: 100%" :disabled="!nfcAdminSubmit"></el-input>
                      </el-form-item>
                    </td>
                  </tr>
                </table>
                <!-- <table class="table-d" v-if="!showAll&&nfsLists.length>0">
                  <tr>
                    <td class="title" style="width:10%!important;;background: #fafafa;">序号</td>
                    <td class="title" style="width:90%!important;;background: #fafafa;">NFS</td>
                  </tr>
                  <tr v-for="(item,index) in nfsLists" :key="index">
                    <td style="width:10%!important;">{{index+1}}</td>
                    <td style="width:90%!important;">{{item.name}}</td>
                  </tr>
                </table> -->
                <el-table :data="nfsLists" border style="width: 100%;margin-bottom:10px" max-height="104px" v-if="!showAll&&nfsLists.length>0">
                  <el-table-column type="index" label="序号" width="50"></el-table-column>
                  <el-table-column prop="name" label="NFS"></el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div>
        <!-- Cost Analysis||Risk Identification -->
        <div class="cost_analysis" v-if="showAll">
          <div class="info_box_title" style="padding-top:10px">
            <p class="line"></p>
            <p class="info_title">Cost Analysis</p>
          </div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item style="width:100%" prop="costImpactVsCurrentPrice" label-width="230px">
                <p slot="label">Cost Impact (K RMB) vs Current Price</p>
                <!-- <p slot="label" style="line-height: 1;"></p> -->
                <el-input :disabled="!nfcAdminSubmit" type="textarea" :rows="2" v-model="formData.costImpactVsCurrentPrice" style="width: 100%" :title="formData.costImpactVsCurrentPrice"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item style="width:100%" prop="currentPrice" label-width="230px">
                <p slot="label">Identify Benchmark or Index</p>
                <p slot="label" style="line-height: 1;">(if available)Current Price</p>
                <el-input v-model="formData.currentPrice" style="width: 100%" :disabled="!nfcAdminSubmit" type="textarea" :rows="2"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item style="width:100%" prop="futureMarketPrice" label-width="230px">
                <p slot="label">Future Market Price(if available)</p>
                <!-- <p slot="label" style="line-height: 1;">(if available)</p> -->
                <el-input v-model="formData.futureMarketPrice" style="width: 100%" :disabled="!nfcAdminSubmit" type="textarea" :rows="2"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item style="width:100%" prop="costImpactVsFuturePrice" label-width="230px">
                <p slot="label">Cost Impact (K RMB)</p>
                <p slot="label" style="line-height: 1;">vs Future Price (if available)</p>
                <el-input :disabled="!nfcAdminSubmit" type="textarea" :rows="2" v-model="formData.costImpactVsFuturePrice" style="width: 100%" :title="formData.costImpactVsFuturePrice"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item style="width:100%" prop="riskIdentifiHedgeJustifi" :rules="fpaRules.riskIdentifiHedgeJustifi" label-width="230px">
                <p slot="label">Risk Identification & Hedge Justification</p>
                <!-- <p slot="label" style="line-height: 1;"></p> -->
                <el-input :disabled="!nfcAdminSubmit" type="textarea" :rows="5" v-model="formData.riskIdentifiHedgeJustifi" style="width: 100%" :title="formData.riskIdentifiHedgeJustifi"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- LTO Material Information --> <!-- nfcAdminSubmit -->
          <div v-if="!isSupplier && (nfcAdminSubmit||formData.status==='nfcApproved'||formData.status==='headOfMenuSolution'||formData.status==='menuVpApproving'||formData.status==='scmVpApproving'||formData.status==='CFOApproving'||formData.status==='CEOApproving'||formData.status==='CGOApproving'||formData.status==='approved')">
            <div class="info_box_title" style="padding-top:10px">
              <p class="line"></p>
              <p class="info_title">LTO Material Information</p>
            </div>
            <el-row :gutter="10">
              <el-col :span="5">
                <el-form-item style="width:100%" label="Total LTO SKU Count" label-width="130px">
                  <el-input v-model="formData.skuQty" style="width: 100%" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item style="width:100%" label="Total Supplier Count" label-width="130px">
                  <el-input v-model="formData.supplierQty" style="width: 100%" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="24">
                <div style="display: flex;">
                  <div style="width: 210px;line-height: 32px;color: #606266;">
                    To Compare with Menu Cutting Cost,
                  </div>
                  <div style="width: calc((100% - 230px) / 3);">
                    <el-form-item style="width:100%" prop="samePriceQty" label="Price Same SKU Count" label-width="150px" :rules="fpaRules.samePriceQty">
                      <el-input v-model="formData.samePriceQty" style="width: 100%;" :disabled="!nfcAdminSubmit" @input="handleInput($event,'samePriceQty')"></el-input>
                    </el-form-item>
                  </div>
                  <div style="width: calc((100% - 230px) / 3);margin-left: 10px;">
                    <el-form-item style="width:100%" prop="decPriceQty" label="Price Reduction SKU Count" label-width="175px" :rules="fpaRules.decPriceQty">
                      <el-input v-model="formData.decPriceQty" style="width: 100%;" :disabled="!nfcAdminSubmit" @input="handleInput($event,'decPriceQty')"></el-input>
                    </el-form-item>
                  </div>
                  <div style="width: calc((100% - 230px) / 3);margin-left: 10px;">
                    <el-form-item style="width:100%" prop="incPriceQty" label="Price Rise SKU Count" label-width="145px" :rules="fpaRules.incPriceQty">
                      <el-input v-model="formData.incPriceQty" style="width: 100%" :disabled="!nfcAdminSubmit" @input="handleInput($event,'incPriceQty')"></el-input>
                    </el-form-item>
                  </div>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item style="width:100%" label="Price Fluctuation Reason" label-width="150px">
                  <el-input v-model="formData.priceVolatilityReason" type="textarea" rows="3" style="width: 100%" :disabled="!nfcAdminSubmit"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </el-form>
    <div class="tab_box" v-if="(formData.status=='new'&&nfsLists.length>0)||formData.status!='new'||canDownload||formData.ttFpaLtoCampaignId > 0">
      <el-tabs v-model="activeName" style="margin-top: 10px ;">
        <el-tab-pane label="PQCP" name="fpaPqcpTab" v-if="formData.status=='new'&&nfsLists.length>0">
          <el-tabs type="border-card" v-model="selName" @tab-click="handleClick">
            <el-tab-pane label="全部" name="all">
              <el-button v-if="canUpdate" type="primary" @click="fpaNfsAllDownload" style="margin-right:10px">
                {{ $t('fpaManage.ltoCampaign.download') }}
              </el-button>
              <UTable :data="formData.fpaLtoPqcnList" :height="520" use-virtual max-height="520" ref="fpaLtoPqcnList" @selection-change="handleFpaLtoPqcnChange" border highlight-current-row style="margin-top: 10px ;" class="campaign_table PQCP">
                <u-table-column align="center" type="index" width="55"></u-table-column>
                <!-- Supplier -->
                <u-table-column align="center" prop="supplierName" label="Supplier" width="150px" show-overflow-tooltip></u-table-column>
                <!-- Facility -->
                <u-table-column align="center" prop="plantName" label="Facility" width="150px" show-overflow-tooltip></u-table-column>
                <!-- Supplied DC -->
                <u-table-column align="center" prop="dcIdList" label="Supplied DC" width="300px">
                  <template slot-scope="scope">
                    <ic-select class="multiple_sel" style="width:100%" table="BASE" field="DC" v-model="scope.row.dcIdList" :multiple="true" disabled></ic-select>
                  </template>
                </u-table-column>
                <!-- 供应物料&# -->
                <u-table-column align="center" prop="localItem" :label="$t('fpaManage.ltoCampaign.localItem')" width="130px" show-overflow-tooltip></u-table-column>
                <!-- 供应物料 Ingredient -->
                <u-table-column align="center" prop="ingredient" label="供应物料 Ingredient" width="150px" show-overflow-tooltip></u-table-column>
                <!-- 对比物料&# -->
                <u-table-column align="center" prop="localItemContrast" :label="$t('fpaManage.ltoCampaign.localItemContrast')" width="130px" show-overflow-tooltip></u-table-column>
                <!-- 对比物料 Ingredient -->
                <u-table-column align="center" prop="ingredientContrast" label="对比物料 Ingredient" width="150px" show-overflow-tooltip></u-table-column>
                <!-- Menu Item -->
                <u-table-column align="center" prop="newMenuItemName" label="Menu Item" width="150px" show-overflow-tooltip></u-table-column>
                <!-- Price per Case(wo VAT) -->
                <u-table-column align="center" prop="purchaseForcast" label="Price per Case(wo VAT)" width="150px" show-overflow-tooltip></u-table-column>
                <!-- 对比物料Price per Case(wo VAT) -->
                <u-table-column align="center" prop="pricePerCaseContrast" label="对比物料Price per Case(wo VAT)" width="195px" show-overflow-tooltip></u-table-column>
                <!-- VAT -->
                <u-table-column show-overflow-tooltip align="center" prop="vat" label="VAT" width="80px">
                  <template slot-scope="scope">
                    <ic-select class="multiple_sel" style="width:100%" table="TM_MATERIAL_RECORD" field="URCHASE_TAX_RATE" v-model="scope.row.vat" :disabled="true"></ic-select>
                  </template>
                </u-table-column>
                <!-- Price per UNIT(RMB EXCL.VAT) -->
                <u-table-column show-overflow-tooltip align="center" label="Price per UNIT(RMB EXCL.VAT)" width="250px">
                  <u-table-column align="center" prop="pricePerUnit" label="Price" width="150px">
                    <template slot-scope="scope">
                      <el-input :value="scope.row.pricePerUnit" disabled></el-input>
                    </template>
                  </u-table-column>
                  <u-table-column show-overflow-tooltip align="center" prop="unit" label="Unit" width="150px">
                    <template slot-scope="scope">
                      <ic-select class="multiple_sel" style="width:100%" table="TT_FPA_LTO_PQCN" field="UNIT" v-model="scope.row.unit" :disabled="true"></ic-select>
                    </template>
                  </u-table-column>
                </u-table-column>
                <!-- 对比物料Price per UNIT(RMB EXCL.VAT) -->
                <u-table-column show-overflow-tooltip align="center" label="对比物料Price per UNIT(RMB EXCL.VAT)" width="250px">
                  <u-table-column align="center" prop="pricePerUnitContrast" label="Price" width="150px">
                    <template slot-scope="scope">
                      <el-input :value="scope.row.pricePerUnitContrast | thousandSeparator" disabled></el-input>
                    </template>
                  </u-table-column>
                  <u-table-column show-overflow-tooltip align="center" prop="unitContrast" label="Unit" width="150px">
                    <template slot-scope="scope">
                      <ic-select class="multiple_sel" style="width:100%" table="TT_FPA_LTO_PQCN" field="UNIT" v-model="scope.row.unitContrast" :disabled="true"></ic-select>
                    </template>
                  </u-table-column>
                </u-table-column>
                <!-- Price Valid Date -->
                <u-table-column align="center" label="Price Valid Date" width="150px">
                  <u-table-column align="center" prop="priceValidDateFrom" label="From" width="100px" show-overflow-tooltip></u-table-column>
                  <u-table-column align="center" prop="priceValidDateTo" label="to" width="100px" show-overflow-tooltip></u-table-column>
                </u-table-column>
                <!-- Total Estimated Qty(Case) -->
                <u-table-column align="center" prop="totalEstimatedQty" label="Total Estimated Qty(Case)" width="150px" show-overflow-tooltip></u-table-column>
                <!-- Total Estimated Amount (RMB) -->
                <u-table-column align="center" prop="totalEstimatedAmount" label="Total Estimated Amount (RMB)" width="220px">
                  <template slot-scope="scope">
                    {{ scope.row.totalEstimatedAmount | fix(2) | thousandSeparator }}
                  </template>
                </u-table-column>
                <!-- Delivery Type -->
                <u-table-column align="center" prop="transportaionMethod" label="Delivery Type" width="150px">
                  <template slot-scope="scope">
                    <ic-select class="multiple_sel" style="width:100%" table="TT_FPA_LTO_PQCN" field="DIS_TYPE" v-model="scope.row.transportaionMethod" :disabled="true"></ic-select>
                  </template>
                </u-table-column>
                <!-- Trade Term -->
                <u-table-column show-overflow-tooltip align="center" prop="tradeTerm" label="Trade Term" width="180px">
                  <template slot-scope="scope">
                    <ic-select class="multiple_sel" style="width:100%" table="TM_MATERIAL_RECORD" field="PRICE_TYPE" v-model="scope.row.tradeTerm" :disabled="true"></ic-select>
                  </template>
                </u-table-column>
                <!-- Freight -->
                <u-table-column align="center" prop="freight" label="Freight" width="150px" show-overflow-tooltip></u-table-column>
                <!-- Total Cost(without VAT) -->
                <u-table-column align="center" prop="totalCost" label="Total Cost(without VAT)" width="170px" show-overflow-tooltip>
                  <template slot-scope="scope">{{ scope.row.totalCost  | thousandSeparator }}</template>
                </u-table-column>
                <!-- Promotion Date  -->
                <u-table-column align="center" label="Promotion Date" width="300px">
                  <u-table-column align="center" prop="promotionDateFrom" label="From" width="150px" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-date-picker v-model="scope.row.promotionDateFrom" type="date" value-format="yyyy-MM-dd" style="width:100%" disabled></el-date-picker>
                    </template>
                  </u-table-column>
                  <u-table-column align="center" prop="promotionDateTo" label="to" width="150px" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-date-picker v-model="scope.row.promotionDateTo" type="date" value-format="yyyy-MM-dd" style="width:100%" disabled></el-date-picker>
                    </template>
                  </u-table-column>
                </u-table-column>
                <!-- Remark -->
                <u-table-column show-overflow-tooltip align="center" prop="remark" label="Remark" width="180px"></u-table-column>
                <!-- Packing Size per CASE -->
                <u-table-column show-overflow-tooltip align="center" prop="packagingSize" label="Packing Size per CASE" width="150px"></u-table-column>
                <!-- 对比物料Packing Size per CASE -->
                <u-table-column show-overflow-tooltip align="center" prop="packingSizePerCaseContrast" label="对比物料Packing Size per CASE" width="220px"></u-table-column>
                <!-- Net Content -->
                <u-table-column align="center" prop="netContent" label="Net Content" width="150px">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.netContent" placeholder="KG/L" disabled></el-input>
                  </template>
                </u-table-column>
                <!-- 对比物料Net Content -->
                <u-table-column align="center" prop="netContentContrast" label="对比物料Net Content" width="150px">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.netContentContrast" placeholder="KG/L" disabled></el-input>
                  </template>
                </u-table-column>
                <!-- NFC审批人 -->
                <u-table-column align="center" prop="nfcCategoryLeaderId" label="NFS审批人" min-width="200px">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.nfcCategoryLeaderId" disabled>
                      <el-option :key="index" v-for="(item,index) in nfcCategoryLeaderList" :label="item.userName" :value="item.tmUserId"></el-option>
                    </el-select>
                  </template>
                </u-table-column>
                <!-- SS Category leader" -->
                <u-table-column align="center" prop="ssCategoryLeaderId" label="SS Category leader" min-width="200px">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.ssCategoryLeaderId" disabled>
                      <el-option :key="index" v-for="(item,index) in ssCategoryLeaderList" :label="item.userName" :value="item.tmUserId"></el-option>
                    </el-select>
                  </template>
                </u-table-column>
              </UTable>
            </el-tab-pane>
            <el-tab-pane v-for="(item,index) in childTabs" :label="item.name" :key="index" :name="String(index)">
              <el-form :model="item" :ref="'ruleForm'+`${index}`">
                <el-row type="flex" justify="start" v-if="ms_userId==item.tmUserId">
                  <el-button v-if="canUpdate" type="primary" @click="fpaNfsAdd(item)">{{ $t('common.addNew') }}</el-button>
                  <el-button v-if="canUpdate" type="primary" @click="copyLine(item)">{{ $t('common.copyLine') }}</el-button>
                  <el-button v-if="canUpdate" type="danger" @click="fpaNfsDel(item)">{{ $t('common.del') }}</el-button>
                  <el-button v-if="canUpdate" type="primary" @click="fpaNfsDownload(item)" style="margin-right:10px">
                    {{ $t('fpaManage.ltoCampaign.download') }}
                  </el-button>
                  <el-upload v-if="canUpdate" action="" :show-file-list="false" :ref="'upload'+`${index}`" class="upload-inline-block" :http-request="uploadTemplateConfirm" :headers="headers" accept=".xls, .xlsx" :limit="1">
                    <el-button slot="trigger" size="small" type="primary">
                      {{ $t('fpaManage.ltoCampaign.import') }}
                    </el-button>
                  </el-upload>
                </el-row>
                <UTable :data="item.lists" :height="520" use-virtual max-height="520" :ref="'childLists'+`${index}`" @selection-change="handleFpaLtoPqcnChange" border highlight-current-row style="margin-top: 10px ;" class="campaign_table PQCP">
                  <u-table-column align="center" type="selection" width="55" v-if="ms_userId==item.tmUserId"></u-table-column>
                  <!-- Supplier -->
                  <u-table-column align="center" prop="supplierName" label="Supplier" width="150px" show-overflow-tooltip></u-table-column>
                  <!-- Facility -->
                  <u-table-column align="center" prop="plantName" label="Facility" width="150px" show-overflow-tooltip></u-table-column>
                  <!-- Supplied DC -->
                  <u-table-column align="center" prop="dcIdList" label="Supplied DC" width="300px">
                    <template slot-scope="scope">
                      <el-form-item class="fpaPermanentDetail" :prop="'lists.' + scope.$index + '.dcIdList'" style="width:100%" :rules="dcIdListRules(scope.$index,scope.row)">
                        <ic-select class="multiple_sel" style="width:100%" table="BASE" field="DC" v-model="scope.row.dcIdList" @change="dcsChange(scope.row,$event)" :multiple="true" :clearable="true" :disabled="!canUpdate||(ms_userId!=item.tmUserId&&!isOwner)"></ic-select>
                      </el-form-item>
                    </template>
                  </u-table-column>
                  <!-- 供应物料&# -->
                  <u-table-column align="center" prop="localItem" :label="$t('fpaManage.ltoCampaign.localItem')" width="145px">
                    <template slot-scope="scope">
                      <el-form-item class="fpaPermanentDetail" :prop="'lists.' + scope.$index + '.localItem'">
                        <!-- @input="localItemBlur($event,scope.row)"  -->
                        <!-- :disabled="!canUpdate||(ms_userId!=item.tmUserId&&!isOwner)" -->
                        <MaterialInput v-model="scope.row.localItem" @pick="pickMaterial($event,scope.$index,scope.row)" :mark="!canUpdate||(ms_userId!=item.tmUserId&&!isOwner)?'1':'0'" :disabled="true"></MaterialInput>
                      </el-form-item>
                    </template>
                  </u-table-column>
                  <!-- 供应物料 Ingredient -->
                  <u-table-column align="center" prop="ingredient" label="供应物料 Ingredient" width="150px">
                    <template slot-scope="scope">
                      <el-form-item class="fpaPermanentDetail" :prop="'lists.' + scope.$index + '.ingredient'" :rules="ingredientRules(scope.$index,scope.row)">
                        <el-input v-model="scope.row.ingredient" disabled></el-input>
                      </el-form-item>
                    </template>
                  </u-table-column>
                  <!-- 对比物料&# -->
                  <u-table-column align="center" prop="localItemContrast" :label="$t('fpaManage.ltoCampaign.localItemContrast')" width="145px">
                    <template slot-scope="scope">
                      <!-- :rules="localItemContrastRules(scope.$index,scope.row)" -->
                      <!-- @input="localItemContrastBlur($event,scope.row)" -->
                      <!-- :disabled="!canUpdate||(ms_userId!=item.tmUserId&&!isOwner)" -->
                      <el-form-item class="fpaPermanentDetail" :prop="'lists.' + scope.$index + '.localItemContrast'">
                        <MaterialInput v-model="scope.row.localItemContrast" @pick="pickMaterial1($event,scope.row)" :mark="!canUpdate||(ms_userId!=item.tmUserId&&!isOwner)?'2':'0'" :disabled="true"></MaterialInput>
                      </el-form-item>
                    </template>
                  </u-table-column>
                  <!-- 对比物料 Ingredient -->
                  <u-table-column align="center" prop="ingredientContrast" label="对比物料 Ingredient" width="150px">
                    <template slot-scope="scope">
                      <el-form-item class="fpaPermanentDetail" :prop="'lists.' + scope.$index + '.ingredientContrast'" :rules="eightBitCodeNameRules(scope.$index,scope.row)">
                        <el-input v-model="scope.row.ingredientContrast" disabled></el-input>
                      </el-form-item>
                    </template>
                  </u-table-column>
                  <!-- Menu Item -->
                  <u-table-column align="center" prop="newMenuItemName" label="Menu Item" width="150px">
                    <template slot-scope="scope">
                      <el-form-item class="fpaPermanentDetail" :prop="'lists.' + scope.$index + '.newMenuItemName'" :rules="newMenuItemNameRules(scope.$index,scope.row)">
                        <el-input v-model="scope.row.newMenuItemName" placeholder="文字描述" :disabled="!canUpdate||(ms_userId!=item.tmUserId&&!isOwner)"></el-input>
                      </el-form-item>
                    </template>
                  </u-table-column>
                  <!-- Price per Case(wo VAT) -->
                  <u-table-column align="center" prop="purchaseForcast" label="Price per Case(wo VAT)" width="150px">
                    <template slot-scope="scope">
                      <el-form-item class="fpaPermanentDetail" :prop=" 'lists.' + scope.$index + '.purchaseForcast' " :rules="purchaseForcastRules(scope.$index,scope.row)">
                        <el-input v-model="scope.row.purchaseForcast" @change="setPurchaseForcast(scope.row)" :disabled="!canUpdate||(ms_userId!=item.tmUserId&&!isOwner)"></el-input>
                      </el-form-item>
                    </template>
                  </u-table-column>
                  <!-- 对比物料Price per Case(wo VAT) -->
                  <u-table-column align="center" prop="pricePerCaseContrast" label="对比物料Price per Case(wo VAT)" width="195px">
                    <template slot-scope="scope">
                      <el-form-item class="fpaPermanentDetail" :prop=" 'lists.' + scope.$index + '.pricePerCaseContrast'">
                        <el-input :value="scope.row.pricePerCaseContrast | thousandSeparator" @change="setPricePerCaseContrast(scope.row)" disabled></el-input>
                      </el-form-item>
                    </template>
                  </u-table-column>
                  <!-- VAT -->
                  <u-table-column align="center" prop="vat" label="VAT" width="90px">
                    <template slot-scope="scope">
                      <el-form-item class="fpaPermanentDetail" :prop=" 'lists.' + scope.$index + '.vat' " :rules="vatRules(scope.$index,scope.row)">
                        <ic-select class="multiple_sel" style="width:100%" table="TM_MATERIAL_RECORD" field="URCHASE_TAX_RATE" v-model="scope.row.vat" :clearable="true" :disabled="!canUpdate||(ms_userId!=item.tmUserId&&!isOwner)"></ic-select>
                      </el-form-item>
                    </template>
                  </u-table-column>
                  <!-- Price per UNIT(RMB EXCL.VAT) -->
                  <u-table-column show-overflow-tooltip align="center" label="Price per UNIT(RMB EXCL.VAT)" width="250px">
                    <u-table-column align="center" prop="pricePerUnit" label="Price" width="150px">
                      <template slot-scope="scope">
                        <el-form-item class="fpaPermanentDetail" :prop=" 'lists.' + scope.$index + '.pricePerUnit' " :rules="pricePerUnitRules(scope.$index,scope.row)">
                          <el-input v-model="scope.row.pricePerUnit" @change="setPricePerUnit(scope.row)" :disabled="!canUpdate||(ms_userId!=item.tmUserId&&!isOwner)"></el-input>
                        </el-form-item>
                      </template>
                    </u-table-column>
                    <u-table-column align="center" prop="unit" label="Unit" width="150px">
                      <template slot-scope="scope">
                        <el-form-item class="fpaPermanentDetail" :prop=" 'lists.' + scope.$index + '.unit' " :rules="unitRules(scope.$index,scope.row)">
                          <ic-select class="multiple_sel" style="width:100%" table="TT_FPA_LTO_PQCN" field="UNIT" v-model="scope.row.unit" :clearable="true" :disabled="!canUpdate||(ms_userId!=item.tmUserId&&!isOwner)"></ic-select>
                        </el-form-item>
                      </template>
                    </u-table-column>
                  </u-table-column>
                  <!-- 对比物料Price per UNIT(RMB EXCL.VAT) -->
                  <u-table-column show-overflow-tooltip align="center" label="对比物料Price per UNIT(RMB EXCL.VAT)" width="250px">
                    <u-table-column align="center" prop="pricePerUnitContrast" label="Price" width="150px">
                      <template slot-scope="scope">
                        <el-form-item class="fpaPermanentDetail" :prop=" 'lists.' + scope.$index + '.pricePerUnitContrast' " :rules="pricePerUnitContrastRules(scope.$index,scope.row)">
                          <el-input v-model="scope.row.pricePerUnitContrast" @change="setPricePerUnitContrast(scope.row)" :disabled="!canUpdate||(ms_userId!=item.tmUserId&&!isOwner)||scope.row.localItemContrast=='NA'"></el-input>
                        </el-form-item>
                      </template>
                    </u-table-column>
                    <u-table-column show-overflow-tooltip align="center" prop="unitContrast" label="Unit" width="150px">
                      <template slot-scope="scope">
                        <el-form-item class="fpaPermanentDetail" :prop=" 'lists.' + scope.$index + '.unitContrast' " :rules="unitContrastRules(scope.$index,scope.row)">
                          <ic-select class="multiple_sel" style="width:100%" table="TT_FPA_LTO_PQCN" field="UNIT" v-model="scope.row.unitContrast" :clearable="true" :disabled="!canUpdate||(ms_userId!=item.tmUserId&&!isOwner)||scope.row.localItemContrast=='NA'"></ic-select>
                        </el-form-item>
                      </template>
                    </u-table-column>
                  </u-table-column>
                  <!-- Price Valid Date -->
                  <u-table-column align="center" label="Price Valid Date" width="150px">
                    <u-table-column align="center" prop="priceValidDateFrom" label="From" width="150px">
                      <template slot-scope="scope">
                        <el-form-item class="fpaPermanentDetail" :prop=" 'lists.' + scope.$index + '.priceValidDateFrom' " :rules="priceValidDateFromRules(scope.$index,scope.row)">
                          <el-date-picker type="date" placeholder="选择日期" v-model="scope.row.priceValidDateFrom" value-format="yyyy-MM-dd" style="width: 100%;" :disabled="!canUpdate||(ms_userId!=item.tmUserId&&!isOwner)"></el-date-picker>
                        </el-form-item>
                      </template>
                    </u-table-column>
                    <u-table-column align="center" prop="priceValidDateTo" label="To" width="150px">
                      <template slot-scope="scope">
                        <el-form-item class="fpaPermanentDetail" :prop=" 'lists.' + scope.$index + '.priceValidDateTo' " :rules="priceValidDateToRules(scope.$index,scope.row)">
                          <el-date-picker type="date" placeholder="选择日期" v-model="scope.row.priceValidDateTo" value-format="yyyy-MM-dd" style="width: 100%;" :disabled="!canUpdate||(ms_userId!=item.tmUserId&&!isOwner)"></el-date-picker>
                        </el-form-item>
                      </template>
                    </u-table-column>
                  </u-table-column>
                  <!-- Total Estimated Qty(Case) -->
                  <u-table-column align="center" prop="totalEstimatedQty" label="Total Estimated Qty(Case)" width="200px">
                    <template slot-scope="scope">
                      <el-form-item class="fpaPermanentDetail" :prop=" 'lists.' + scope.$index + '.totalEstimatedQty'" :rules="totalEstimatedQtyRules(scope.$index,scope.row)">
                        <el-input @change="countPqcp(scope.row)" v-model="scope.row.totalEstimatedQty" :disabled="!canUpdate||(ms_userId!=item.tmUserId&&!isOwner)"></el-input>
                      </el-form-item>
                    </template>
                  </u-table-column>
                  <!-- Total Estimated Amount (RMB) -->
                  <u-table-column align="center" prop="totalEstimatedAmount" label="Total Estimated Amount (RMB)" width="220px">
                    <template slot-scope="scope">
                      {{ scope.row.totalEstimatedAmount | fix(2) | thousandSeparator }}
                    </template>
                  </u-table-column>
                  <!-- Delivery Type -->
                  <u-table-column align="center" prop="transportaionMethod" label="Delivery Type" width="150px">
                    <template slot-scope="scope">
                      <el-form-item class="fpaPermanentDetail" :prop=" 'lists.' + scope.$index + '.transportaionMethod' " :rules="transportaionMethodRules(scope.$index,scope.row)">
                        <!-- <el-select v-model="scope.row.transportaionMethod" :disabled="!canUpdate||ms_userId!=item.tmUserId">
                          <el-option :key="index" v-for="(item,index) in newTransportaionMethodList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                        </el-select> -->
                        <ic-select class="multiple_sel" style="width:100%" table="TT_FPA_LTO_PQCN" field="DIS_TYPE" @change="deliveryTypeChange($event,scope.row)" v-model="scope.row.transportaionMethod" :clearable="true" :disabled="!canUpdate||(ms_userId!=item.tmUserId&&!isOwner)"></ic-select>
                      </el-form-item>
                    </template>
                  </u-table-column>
                  <!-- Trade Term -->
                  <u-table-column show-overflow-tooltip align="center" prop="tradeTerm" label="Trade Term" width="250px">
                    <template slot-scope="scope">
                      <el-form-item class="fpaPermanentDetail" :prop=" 'lists.' + scope.$index + '.tradeTerm' " :rules="tradeTermRules(scope.$index,scope.row)">
                        <ic-select class="multiple_sel" style="width:100%" table="TM_MATERIAL_RECORD" field="PRICE_TYPE" v-model="scope.row.tradeTerm" :clearable="true" :disabled="!canUpdate||(ms_userId!=item.tmUserId&&!isOwner)"></ic-select>
                      </el-form-item>
                    </template>
                  </u-table-column>
                  <!-- Freight -->
                  <u-table-column align="center" prop="freight" label="Freight" width="150px">
                    <template slot-scope="scope">
                      <el-form-item class="fpaPermanentDetail" :prop="`lists.${scope.$index}.freight`" :rules="freightRules(scope.$index,scope.row)">
                        <el-input @change="countPqcp(scope.row)" v-model="scope.row.freight" :disabled="!canUpdate||(ms_userId!=item.tmUserId&&!isOwner)||scope.row.transportaionMethod=='DC'"></el-input>
                      </el-form-item>
                    </template>
                  </u-table-column>
                  <!-- Total Cost(without VAT) -->
                  <u-table-column align="center" prop="totalCost" label="Total Cost(without VAT)" width="180px">
                    <template slot-scope="scope">{{ scope.row.totalCost  | thousandSeparator }}</template>
                  </u-table-column>
                  <!-- Promotion Date  -->
                  <u-table-column align="center" label="Promotion Date" width="150px">
                    <u-table-column align="center" prop="promotionDateFrom" label="From" width="150px">
                      <template slot-scope="scope">
                        <el-form-item class="fpaPermanentDetail" :prop="`lists.${scope.$index}.promotionDateFrom`" :rules="promotionDateFromRules(scope.$index,scope.row)">
                          <el-date-picker v-model="scope.row.promotionDateFrom" type="date" value-format="yyyy-MM-dd" style="width:100%" :disabled="!canUpdate||(ms_userId!=item.tmUserId&&!isOwner)"></el-date-picker>
                        </el-form-item>
                      </template>
                    </u-table-column>
                    <u-table-column align="center" prop="promotionDateTo" label="To" width="150px">
                      <template slot-scope="scope">
                        <el-form-item class="fpaPermanentDetail" :prop="`lists.${scope.$index}.promotionDateTo`" :rules="promotionDateToRules(scope.$index,scope.row)">
                          <el-date-picker v-model="scope.row.promotionDateTo" type="date" value-format="yyyy-MM-dd" style="width:100%" :disabled="!canUpdate||(ms_userId!=item.tmUserId&&!isOwner)"></el-date-picker>
                        </el-form-item>
                      </template>
                    </u-table-column>
                  </u-table-column>
                  <!-- Remark -->
                  <u-table-column show-overflow-tooltip align="center" prop="remark" label="Remark" width="250px">
                    <template slot-scope="scope">
                      <el-form-item class="fpaPermanentDetail" :prop=" 'lists.' + scope.$index + '.remark' " :rules="remarkRules(scope.$index,scope.row)">
                        <el-input v-model="scope.row.remark" :disabled="!canUpdate||(ms_userId!=item.tmUserId&&!isOwner)"></el-input>
                      </el-form-item>
                    </template>
                  </u-table-column>
                  <!-- Packing Size per CASE -->
                  <u-table-column show-overflow-tooltip align="center" prop="packagingSize" label="Packing Size per CASE" width="180px">
                    <template slot-scope="scope">
                      <el-form-item class="fpaPermanentDetail" :prop=" 'lists.' + scope.$index + '.packagingSize' " :rules="packagingSizeRules(scope.$index,scope.row)">
                        <el-input v-model="scope.row.packagingSize" :disabled="!canUpdate||(ms_userId!=item.tmUserId&&!isOwner)"></el-input>
                      </el-form-item>
                    </template>
                  </u-table-column>
                  <!-- 对比物料Packing Size per CASE -->
                  <u-table-column show-overflow-tooltip align="center" prop="packingSizePerCaseContrast" label="对比物料Packing Size per CASE" width="220px">
                    <template slot-scope="scope">
                      <el-form-item class="fpaPermanentDetail" :prop=" 'lists.' + scope.$index + '.packingSizePerCaseContrast' " :rules="packingSizePerCaseContrastRules(scope.$index,scope.row)">
                        <el-input v-model="scope.row.packingSizePerCaseContrast" :disabled="!canUpdate||(ms_userId!=item.tmUserId&&!isOwner)||scope.row.localItemContrast=='NA'"></el-input>
                      </el-form-item>
                    </template>
                  </u-table-column>
                  <!-- Net Content -->
                  <u-table-column align="center" prop="netContent" label="Net Content" width="150px">
                    <template slot-scope="scope">
                      <el-form-item class="fpaPermanentDetail" :prop="`lists.${scope.$index}.netContent`" :rules="netContentRules(scope.$index,scope.row)">
                        <el-input v-model="scope.row.netContent" placeholder="KG/L" :disabled="!canUpdate||(ms_userId!=item.tmUserId&&!isOwner)"></el-input>
                        <!-- <ic-select class="multiple_sel" style="width:100%" table="TT_FPA_LTO_PQCN" field="NETCONTENT" v-model="scope.row.netContent" :clearable="true" :disabled="!canUpdate||ms_userId!=item.tmUserId"></ic-select> -->
                      </el-form-item>
                    </template>
                  </u-table-column>
                  <!-- 对比物料Net Content -->
                  <u-table-column align="center" prop="netContentContrast" label="对比物料Net Content" width="150px">
                    <template slot-scope="scope">
                      <el-form-item class="fpaPermanentDetail" :prop="`lists.${scope.$index}.netContentContrast`" :rules="netContentContrastRules(scope.$index,scope.row)">
                        <el-input v-model="scope.row.netContentContrast" placeholder="KG/L" :disabled="!canUpdate||(ms_userId!=item.tmUserId&&!isOwner)||scope.row.localItemContrast=='NA'"></el-input>
                        <!-- <ic-select class="multiple_sel" style="width:100%" table="TT_FPA_LTO_PQCN" field="NETCONTENT" v-model="scope.row.netContentContrast" :clearable="true" :disabled="!canUpdate||ms_userId!=item.tmUserId||scope.row.localItemContrast=='NA'"></ic-select> -->
                      </el-form-item>
                    </template>
                  </u-table-column>
                  <!-- NFC审批人 -->
                  <u-table-column align="center" prop="nfcCategoryLeaderId" label="NFS审批人" width="150px">
                    <template slot-scope="scope">
                      <el-form-item class="fpaPermanentDetail" :prop="`lists.${scope.$index}.nfcCategoryLeaderId`" :rules="nfcCategoryLeaderIdRules(scope.$index,scope.row)">
                        <el-select v-model="scope.row.nfcCategoryLeaderId" clearable :disabled="!canUpdate||(ms_userId!=item.tmUserId&&!isOwner)">
                          <el-option :key="index" v-for="(item,index) in nfcCategoryLeaderList" :label="item.userName" :value="item.tmUserId"></el-option>
                        </el-select>
                      </el-form-item>
                    </template>
                  </u-table-column>
                  <!-- SS Category leader" -->
                  <u-table-column align="center" prop="ssCategoryLeaderId" label="SS Category leader" width="150x">
                    <template slot-scope="scope">
                      <el-form-item class="fpaPermanentDetail" :prop="`lists.${scope.$index}.ssCategoryLeaderId`" :rules="ssCategoryLeaderIdRules(scope.$index,scope.row)">
                        <el-select v-model="scope.row.ssCategoryLeaderId" clearable :disabled="!canUpdate||(ms_userId!=item.tmUserId&&!isOwner)">
                          <el-option :key="index" v-for="(item,index) in ssCategoryLeaderList" :label="item.userName" :value="item.tmUserId"></el-option>
                        </el-select>
                      </el-form-item>
                    </template>
                  </u-table-column>
                </UTable>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </el-tab-pane>
        <el-tab-pane label="PQCP" name="fpaPqcpTab" v-if="formData.status!='new'">
          <el-form :model="formData" ref="formData2">
            <el-row type="flex" justify="start">
              <el-button v-if="formData.status!='new' && isOwner" type="primary" @click="fpaNfsDownload">{{ $t('fpaManage.ltoCampaign.download') }}</el-button>
              <el-button v-if="(formData.status=='nfcApproving'|| formData.status=='nfcApproved'||formData.status=='reject') && isOwner" type="primary" @click="saveMarks" style="margin-right:10px">{{ $t('fpaManage.ltoCampaign.saveRemark') }}</el-button>
              <el-upload v-if="(formData.status=='nfcApproving'|| formData.status=='nfcApproved'||formData.status=='reject') && isOwner" ref="upload" action="" :show-file-list="false" class="upload-inline-block2" :http-request="uploadUpdateConfirm" :headers="headers" accept=".xls, .xlsx" :limit="1">
                <el-button slot="trigger" size="small" type="primary">
                  {{ $t('fpaManage.ltoCampaign.update') }}
                </el-button>
              </el-upload>
            </el-row>
            <el-table :data="formData.fpaLtoPqcnList" :row-style="changeRowBgColorByIsLocal" max-height="500" ref="fpaLtoPqcnList1" border style="margin-top: 10px ;">
              <el-table-column show-overflow-tooltip align="center" prop="supplierName" label="Supplier" width="300px">
              </el-table-column>
              <el-table-column show-overflow-tooltip align="center" prop="plantName" label="Facility" width="300px">
              </el-table-column>
              <el-table-column show-overflow-tooltip align="center" prop="dcIdList" label="Supplied DC" width="300px">
                <template slot-scope="scope" v-if="scope.row.isLocal=='1'">
                  <ic-select class="multiple_sel" style="width:100%" table="BASE" field="DC" v-model="scope.row.dcIdList" :multiple="true" :clearable="true" disabled></ic-select>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip align="center" prop="newMenuItemName" label="Menu Item" width="300px">
              </el-table-column>
              <el-table-column show-overflow-tooltip align="center" prop="ingredient" label="Ingredient" width="300px">
              </el-table-column>
              <el-table-column show-overflow-tooltip align="center" prop="localItem" label="Local Item#" width="100px">
              </el-table-column>
              <el-table-column show-overflow-tooltip align="center" label="Price per CASE(RMB EXCL. VAT)" width="250px">
                <el-table-column align="center" prop="purchaseForcast" label="Price" width="150px">
                  <template slot-scope="scope">
                    <el-input :value="scope.row.purchaseForcast | thousandSeparator" disabled></el-input>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="unit" label="Unit" width="150px">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.uom" disabled>
                      <el-option :key="index" v-for="(item,index) in uomList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                    </el-select>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column show-overflow-tooltip align="center" prop="vat" label="VAT" width="90px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.vat" disabled>
                    <el-option :key="index" v-for="(item,index) in pqcnVatRateList" :value="item.code" :label="item | inputChoiceI18n"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column align="center" label="Price Valid Date" width="150px">
                <el-table-column align="center" prop="priceValidDateFrom" label="From" width="150px">
                  <template slot-scope="scope">
                    <el-date-picker type="date" placeholder="选择日期" v-model="scope.row.priceValidDateFrom" value-format="yyyy-MM-dd" style="width: 100%;" disabled></el-date-picker>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="priceValidDateTo" label="to" width="150px">
                  <template slot-scope="scope">
                    <el-date-picker v-if="scope.row.isLocal=='1'" type="date" placeholder="选择日期" v-model="scope.row.priceValidDateTo" value-format="yyyy-MM-dd" style="width: 100%;" disabled></el-date-picker>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column show-overflow-tooltip align="center" prop="tradeTerm" label="Trade Term" width="250px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.tradeTerm" disabled>
                    <el-option :key="index" v-for="(item,index) in priceTypeList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip align="center" prop="totalEstimatedQty" label="Total Estimated Qty(Case)" width="200px">
                <template slot-scope="scope">
                  <el-input v-if="scope.row.isLocal=='1'" v-model="scope.row.totalEstimatedQty" disabled></el-input>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip align="center" prop="totalEstimatedAmount" label="Total Estimated Amount (RMB)" width="250px">
                <template slot-scope="scope">
                  <el-input v-if="scope.row.isLocal=='1'" :value="scope.row.totalEstimatedAmount | fix(2) | thousandSeparator" disabled></el-input>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip align="center" prop="transportaionMethod" label="Delivery Type" width="150px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.transportaionMethod" disabled>
                    <el-option :key="index" v-for="(item,index) in newTransportaionMethodList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip align="center" prop="freight" label="Freight" width="150px">
                <template slot-scope="scope">
                  <el-input v-if="scope.row.isLocal=='1'" disabled :value="scope.row.freight | thousandSeparator"></el-input>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip align="center" prop="totalCost" label="Total Cost(without VAT)" width="250px">
                <template slot-scope="scope">
                  <el-input v-if="scope.row.isLocal=='1'" disabled :value="scope.row.totalCost  | thousandSeparator"></el-input>
                </template>
              </el-table-column>
              <el-table-column align="center" label="Promotion Date From" width="200">
                <template slot-scope="scope">
                  <el-date-picker disabled v-model="scope.row.promotionDateFrom" type="date" value-format="yyyy-MM-dd"></el-date-picker>
                </template>
              </el-table-column>
              <el-table-column align="center" label="Promotion Date To" width="200">
                <template slot-scope="scope">
                  <el-date-picker disabled v-model="scope.row.promotionDateTo" type="date" value-format="yyyy-MM-dd"></el-date-picker>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip align="center" prop="remark" label="Remark" width="250px">
                <template slot-scope="scope">
                  <el-input v-if="scope.row.isLocal=='1'" :disabled="!((formData.status=='nfcApproving'|| formData.status=='nfcApproved'||formData.status=='reject') && isOwner)" v-model="scope.row.remark"></el-input>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="packagingSize" label="Packing Size per CASE" width="250px">
                <template slot-scope="scope">
                  <el-input disabled v-model="scope.row.packagingSize"></el-input>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="netContent" label="Net Content" width="250px">
                <template slot-scope="scope">
                  <el-input disabled v-model="scope.row.netContent"></el-input>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip align="center" v-if="isOwner || attachmentView" :label="$t('common.attachment') ">
                <template slot-scope="scope">
                  <el-button type="primary" v-if="scope.row.isLocal=='1'" @click="localItemAttachmentUpload(scope.row.ttFpaLtoId)">
                    {{ $t('common.attachment') }}
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="nfcCategoryLeaderId" label="NFS 审批人" width="250px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.nfcCategoryLeaderId" disabled>
                    <el-option :key="index" v-for="(item,index) in nfcCategoryLeaderList" :label="item.userName" :value="item.tmUserId"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="ssCategoryLeaderId" label="SS Category Leader" width="250px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.ssCategoryLeaderId" disabled>
                    <el-option :key="index" v-for="(item,index) in ssCategoryLeaderList" :label="item.userName" :value="item.tmUserId"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <!--ltoCampaign:待NFC反馈,NFC已反馈或审批退回   lto:已提交-->
              <el-table-column show-overflow-tooltip v-if="(formData.status=='nfcApproving'|| formData.status=='nfcApproved' ||formData.status=='reject')&&isOwner" align="center" :label="$t('common.operation')" width="150x">
                <template slot-scope="scope">
                  <el-button v-if="scope.row.isLocal=='1' && scope.row.ltoStatus=='submited'" type="primary" @click="ltoPqcnReject(scope.row.ttFpaLtoId)">
                    {{ $t('fpaManage.permanent.auditReject') }}
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="Attachment" name="attachment" v-if="canDownload">
          <el-table :data="attachmentList" border highlight-current-row class="table">
            <el-table-column show-overflow-tooltip prop="type" align="center" label="Type" width="200px"></el-table-column>
            <el-table-column show-overflow-tooltip prop="documentName" label="Attachment">
              <template slot-scope="scope">
                <el-button type="text" @click="attachmentDownload(scope.row)">{{scope.row.documentName}}</el-button>
              </template>
            </el-table-column>
            <el-table-column v-if="nfcAdminSubmit" show-overflow-tooltip label="Operation" width="220px">
              <template slot-scope="scope">
                <el-upload v-if="scope.row.type === 'Other Document'" ref="upload" action="" style="display: inline-block;width: 70px;" :show-file-list="false" :http-request="(uploadFile) => uploadOtherDocConfirm(uploadFile, scope.row)" :headers="headers" :limit="1">
                  <el-button slot="trigger" size="small" type="text">
                    Upload
                  </el-button>
                </el-upload>
                <el-button v-if="scope.row.type === 'Other Document'&&scope.$index > 1" type="text" @click="delOtherDoc(scope.row, scope.$index)">Delete</el-button>
                <el-button v-if="scope.row.type === 'Other Document'" type="text" @click="addOtherDoc">Add</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane v-if="formData.ttFpaLtoCampaignId > 0" label="Audit Record" name="fpaLog">
          <el-table :data="formData.auditLogList" border highlight-current-row class="table">
            <el-table-column show-overflow-tooltip sortable prop="operatorName" align="center" label="Update by"></el-table-column>
            <el-table-column show-overflow-tooltip sortable prop="createDate" align="center" label="Update Time">
              <template slot-scope="scope">
                {{ scope.row.createDate|dateFormatFilter("YYYY-MM-DD") }}
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip sortable prop="action" align="center" label="Update Log"></el-table-column>
            <el-table-column show-overflow-tooltip sortable prop="comments" align="center" label="Suggestion"></el-table-column>
            <el-table-column show-overflow-tooltip sortable align="center" label="Attachment">
              <template slot-scope="scope">
                {{ scope.row.effectiveBeginDate | dateFormatFilter("YYYY-MM-DD HH:mm") }}
                <fileList :files="scope.row.docs"></fileList>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!--附件-->
    <el-dialog :visible.sync="showFileUpload" append-to-body width="80%">
      <FileUpload ref="fileUploadRef" :recType="bizType" :bizId="formData.ttFpaLtoCampaignId" :seq="2" :showFileList="true" :disabled="fileUploadDisabled"></FileUpload>
    </el-dialog>
    <!--审批页面-->
    <el-dialog :visible.sync="showAuditPage" append-to-body width="25%" :title="dialogTitle" class="fpa">
      <el-form :model="formData" ref="formData">
        <!-- <el-row type="flex" justify="center">
          <el-col :span="16">
            <p style="height:40px;line-height:40px">{{$t('fpaManage.permanent.auditRemark')}}</p>
          </el-col>
        </el-row> -->
        <el-row type="flex" justify="center">
          <el-col :span="20" :offset="2">
            <el-form-item :label="$t('fpaManage.permanent.auditRemark')" prop="auditRemark" :class="dialogTitle=='Reject'?'is-required':''" style="width:100%">
              <el-input type="textarea" :rows="3" v-model="formData.auditRemark" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center">
          <el-button type="primary" @click="fpaLtoCampaignApproveConfirm('confirm')">Confirm</el-button>
          <el-button type="primary" @click="showAuditPage=false">Cancel</el-button>
        </el-row>
      </el-form>
    </el-dialog>
    <el-dialog :visible.sync="localItemShowFileUpload" append-to-body width="80%">
      <FileUpload ref="fileUploadRef" :recType="localItemBizType" :bizId="ttFpaLtoId" :seq="0" :showFileList="true" :disabled="localItemFileUploadDisabled"></FileUpload>
    </el-dialog>
    <!--Lto 退回-->
    <el-dialog :visible.sync="showRejectPage" append-to-body width="30%">
      <el-form :model="formData" ref="formData" label-width="120px" style="margin-top: 10px;">
        <el-row>
          <el-col :span="20">
            <!--审批备注-->
            <el-form-item :label="$t('fpaManage.permanent.auditRemark')" prop="auditRemark" class="is-required">
              <el-input type="textarea" :rows="3" width="100%" v-model="formData.auditRemark" />
            </el-form-item>
          </el-col>
        </el-row>
        <div align="center">
          <el-button type="primary" @click="ltoPqcnRejectConfirm('confirm')">Confirm</el-button>
          <el-button type="primary" @click="showRejectPage=false">Cancel</el-button>
        </div>
      </el-form>
    </el-dialog>
    <!-- 选择NFS -->
    <el-dialog :visible.sync="nfsDialog" append-to-body width="80%">
      <NFS ref="nfsRef" @getSelNfs="getSelNfs" :nfsArr="nfsArr" :index="index"></NFS>
    </el-dialog>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import commonFunction from "@/utils/dataTableUtils";
import fpaLtoCampaignApi from "@/api/fpa/fpaLtoCampaign";
import { inputChoiceService } from "@/api/common/input-choice";
import utils from "@/utils/commonFun";
import FileUpload from "@/components/common/fileUpload";
import fileList from "@/components/common/fileList";
import commonFun from "@/utils/commonFun";
import request from "@/utils/request";
import { fileService } from "@/api/common/file-utils";
import MaterialInput from "@/components/page/base-data/materialInput";
import { materialService } from "@/api/base-data/material";
import { Message } from "element-ui";
import moment from "moment";
import NFS from "./nfsDialog";

export default {
  components: { IcSelect, FileUpload, fileList, MaterialInput, NFS },
  name: "fpaLtoCampaignDetail",

  data() {
    return {
      dialogTitle: "",
      childTabs: [],
      nfsLists: [],
      selName: 'all',
      nfsDialog: false,
      ttFpaLtoCampaignId: null,
      showSelSupplierDialog: false,
      supplierIds: [],
      activeName: "fpaPqcpTab",
      attachmentList: [
        {
          type: "System Document",
          documentName: "Download by PDF"
        },
        {
          type: 'Other Document',
          documentName: ""
        }
      ],
      formData: {
        operateType: '',
        ttFpaLtoCampaignId: null,
        fpaNo: '',
        createDate: null,
        createUser: '',
        createBy: null,
        status: '',
        queryStatus: '',
        tmSupplierId: null,
        agreementPurpose: '',
        purchaseFrequency: '',
        salesStartDate: null,
        salesEndDate: null,
        agreementStartDate: null,
        agreementEndDate: null,
        ltoSupplier: '',
        currentPrice: null,
        futureMarketPrice: null,
        productOrCommodityPurchased: '',
        notionalValueOfAgreement: '',
        costImpactVsCurrentPrice: '',
        costImpactVsFuturePrice: '',
        estimateVolumeOfPurchase: '',
        riskIdentifiHedgeJustifi: '',
        supplierCoverageTotal: '',
        mcdCoverageTotal: '',
        plantNames: '',
        plantIds: '',
        auditResult: 'Y',
        auditRemark: '',
        canAudit: false,
        nfsList: [],
        otherNfsPqcnList: [],

        skuQty: "",
        supplierQty: "",
        samePriceQty: "",
        decPriceQty: "",
        incPriceQty: "",
        priceVolatilityReason: ""
      },
      fpaRules: {
        agreementStartDate: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                // this.$my_message(this.$t('fpaManage.ltoCampaign.campaignStartDateCheck'), 'error')
                this.$msg.error(this.$t('fpaManage.ltoCampaign.campaignStartDateCheck'))
                return callback(new Error(' '));
              };
              callback();
            },
            trigger: "change"
          }
        ],
        agreementEndDate: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                // this.$my_message(this.$t('fpaManage.ltoCampaign.campaignEndDateCheck'), 'error')
                this.$msg.error(this.$t('fpaManage.ltoCampaign.campaignEndDateCheck'))
                return callback(new Error(' '));
              };
              callback();
            },
            trigger: "change"
          }
        ],
        productOrCommodityPurchased: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                // this.$my_message(this.$t('fpaManage.permanent.productOrCommodityPurchasedCheck'), 'error')
                this.$msg.error(this.$t('fpaManage.permanent.productOrCommodityPurchasedCheck'))
                return callback(new Error(' '));
              };
              // if (value) {
              //   var reg = /^.{1,1000}$/
              //   if (!reg.test(value)) {
              //     this.$my_message('Product or Commodity Purchased字段已超过系统限制的最大长度1000个字符，请检查.', 'error')
              //     return callback(new Error(' '));
              //   };
              // }
              callback();
            },
            trigger: "blur"
          }
        ],
        // riskIdentifiHedgeJustifi: [
        //   {
        //     validator: (rule, value, callback) => {
        //       if (value) {
        //         var reg = /^.{0,1000}$/
        //         if (!reg.test(value)) {
        //           this.$my_message('Risk Identification & Hedge Justification字段已超过系统限制的最大长度1000个字符，请检查.', 'error')
        //           return callback(new Error(' '));
        //         };
        //       }
        //       callback();
        //     },
        //     trigger: "blur"
        //   }
        // ],
        ssFeedbackHour: [
          {
            validator: (rule, value, callback) => {
              console.log('value', value);
              if (value === 'undefined' || value === null || value === 'NAN' || value === '') {
                // this.$my_message(this.$t('visitPlan.noEmpty'), 'error')
                this.$msg.error(this.$t('visitPlan.noEmpty'))
                return callback(new Error(' '));
              };
              var reg = /^(0|\+?[1-9][0-9]*)$/
              if (!reg.test(value)) {
                // this.$my_message('请输入大于等于0的整数', 'error')
                this.$msg.error('请输入大于等于0的整数')
                return callback(new Error(' '));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        samePriceQty: [
          {required: true, message: "不能为空", trigger: ["blur","change"]}
        ],
        decPriceQty: [
          {required: true, message: "不能为空", trigger: ["blur","change"]}
        ],
        incPriceQty: [
          {required: true, message: "不能为空", trigger: ["blur","change"]}
        ]
      },
      AgreementPickerOptionsStart: {
        // 开始时间小于结束时间
        disabledDate: time => {
          let endTime = this.formData.agreementEndDate;
          if (endTime) {
            return time.getTime() > new Date(endTime).getTime();
          }
        }
      },
      AgreementPickerOptionsEnd: {
        disabledDate: time => {
          let beginTime = this.formData.agreementStartDate;
          if (beginTime) {
            return time.getTime() < new Date(beginTime).getTime() - 24 * 60 * 60 * 1000;
          }
        }
      },
      SalesPickerOptionsStart: {
        // 开始时间小于结束时间
        disabledDate: time => {
          let endTime = this.formData.salesEndDate;
          if (endTime) {
            return time.getTime() > new Date(endTime).getTime();
          }
        }
      },
      SalesPickerOptionsEnd: {
        disabledDate: time => {
          let beginTime = this.formData.salesStartDate;
          if (beginTime) {
            return time.getTime() < new Date(beginTime).getTime() - 24 * 60 * 60 * 1000;
          }
        }
      },
      showAll: true,
      canUpdate: true,
      canMenuVpApprove: false,
      canScmVpApprove: false,
      canCfoVpApprove: false,
      canCeoApprove: false,
      canCgoApprove: false,
      nfcAdminSubmit: false,
      isOwner: false,
      attachmentView: false,
      canDownload: false,
      estimateVolumeOfPurchaseUpdate: false,
      queryStatusList: [],
      agreementPurposeList: [],
      fpaSupplierCoverageSelect: [],
      fpaLtoPqcnSelect: [],
      priceTypeList: [],
      uomList: [],
      unitLists: [],
      innerPackingTypeLists: [],
      productPackagingTypeLists: [],
      pqcnVatRateList: [],
      newTransportaionMethodList: [],
      ssCategoryLeaderList: [],
      nfcCategoryLeaderList: [],
      showFileUpload: false,
      localItemShowFileUpload: false,
      fileUploadDisabled: false,
      localItemFileUploadDisabled: true,
      showAuditPage: false,
      showRejectPage: false,
      auditPerson: localStorage.getItem("ms_username"),
      ms_userId: localStorage.getItem("ms_userId"),
      auditDate: new Date(),
      bizType: 'FPA_LTO_CAMPAIGN',
      localItemBizType: 'FPA_LTO',
      ttFpaLtoId: null,
      rejectFpaLtoId: null,
      rules: {},
      ttFpaLtoPqcnIdLists: [],
      negativeIndex: -1,
      nfsArr: null,
      index: 0,
      isFirstLoad: true, //首次加载
      tabIndex: null,
      curOperation: "N",//判断当前操作是提交还是保存
    };
  },
  created() {
    let ttFpaLtoCampaignId = this.$route.params.ttFpaLtoCampaignId;
    this.ttFpaLtoCampaignId = ttFpaLtoCampaignId;
    this.formData.ttFpaLtoCampaignId = ttFpaLtoCampaignId;
    this.getInputChoiceValues();
    this.getCategoryLeader();
    console.log('localStorage.getItem("ms_userId")', localStorage.getItem("ms_userId"))

    //创建技术文件
    if (ttFpaLtoCampaignId == -1) {
      this.formData.queryStatus = 'new';
      this.formData.status = 'new';
      this.formData.createUser = localStorage.getItem("ms_username");
      var newDate = new Date()
      var y, m, d, h, s, min, curDate
      y = newDate.getFullYear()
      m = newDate.getMonth() + 1 < 9 ? '0' + (newDate.getMonth() + 1) : newDate.getMonth() + 1
      d = newDate.getDate() < 9 ? '0' + newDate.getDate() : newDate.getDate()
      // h = newDate.getHours() < 9 ? '0' + newDate.getHours() : newDate.getHours()
      // min = newDate.getMinutes() < 9 ? '0' + newDate.getMinutes() : newDate.getMinutes()
      // s = newDate.getSeconds() < 9 ? '0' + newDate.getSeconds() : newDate.getSeconds()
      curDate = y + '/' + m + '/' + d
      console.log('curDate', curDate);
      this.formData.createDate = curDate
      this.formData.agreementPurpose = 'newPrice';
      this.canUpdate = true;
      this.showAll = false;
      this.nfcAdminSubmit = false;
      this.isOwner = true;
    } else {
      this.fpaLtoCampaignDetail(ttFpaLtoCampaignId);
    }
  },
  mounted() {
  },
  computed: {
    headers: function () {
      return {
        "x-access-token": localStorage.getItem('token')
      }
    },
    isSupplier() {
      return commonFun.isSupplier()
    },
    pqcpUniqueCount() {
      if(this.nfcAdminSubmit) {
        if(this.formData.fpaLtoPqcnList && this.formData.fpaLtoPqcnList.length > 0) {
          let filterList = this.formData.fpaLtoPqcnList.filter(item => item.isLocal != 0);
          // 统计sku数量
          const skuSet = new Set(filterList.map(item => item.fiveBitCode).filter(code => code !== '' && code != null));
          // 统计供应商数量
          const supplierSet = new Set(filterList.map(item => item.tmSupplierId).filter(name => name !== '' && name != null));
          return {
            supplierQty: supplierSet.size,
            skuQty: skuSet.size
          };
        } else {
          return {
            supplierQty: 0,
            skuQty: 0
          };
        }
      }
    }
  },
  watch: {
    pqcpUniqueCount: {
      handler(val) {
        if(this.nfcAdminSubmit) {
          this.formData.supplierQty = val.supplierQty;
          this.formData.skuQty = val.skuQty;
        }
      },
      immediate: true
    }
  },
  methods: {
    getSelNfs() {
      var items = JSON.parse(sessionStorage.getItem('selectNfs'))
      console.log("🚀 ~ file: newCampaign.vue:1175 ~ getSelNfs ~ items:", items)
      this.nfsLists = [...items]
      var hash = {}
      this.nfsLists = this.nfsLists.reduce(function (item, next) {
        hash[next.tmUserId] ? '' : hash[next.tmUserId] = true && item.push(next)
        return item
      }, [])
      this.nfsDialog = false
    },
    // pricePerCaseContrastRules(index, row) {
    //   return (this.rules["pricePerCaseContrast"] = [
    //     {
    //       validator: (rule, value, callback) => {
    //         // 验证不为空
    //         if (!value) {
    //           // this.$my_message('PQCP信息不全,请维护对比物料Price per Case(wo VAT)!', 'error')
    //           this.$msg.error('PQCP信息不全,请维护对比物料Price per Case(wo VAT)!')
    //           return callback(new Error('Can not be Empty'));
    //         }
    //         callback();
    //       },
    //       trigger: "change"
    //     }
    //   ]);
    // },
    dcIdListRules(index, row) {
      return (this.rules["dcIdList"] = [
        {
          validator: (rule, value, callback) => {
            console.log("🚀 ~ file: newCampaign.vue:1181 ~ dcIdListRules ~ value:", value)
            // 验证不为空
            if (!this.isFirstLoad && (!value || value.length == 0)) {
              // this.$my_message('PQCP信息不全,请维护VAT!', 'error')
              if (this.curOperation === 'Y') {
                this.$msg.error('PQCP信息不全,请维护' + this.tabIndex + '下的Supplied DC!')
              }
              return callback(new Error('Can not be Empty'));
            }
            callback();
          },
          trigger: "change"
        }
      ]);
    },
    // localItemRules(index, row) {
    //   return (this.rules["localItem"] = [
    //     {
    //       validator: (rule, value, callback) => {
    //         // 验证不为空
    //         if (!value) {
    //           // this.$my_message('PQCP信息不全,请维护VAT!', 'error')
    //           this.$msg.error('PQCP信息不全,请维护供应物料&#!')
    //           return callback(new Error('Can not be Empty'));
    //         }
    //         callback();
    //       },
    //       trigger: "change"
    //     }
    //   ]);
    // },
    // localItemContrastRules(index, row) {
    //   return (this.rules["localItemContrast"] = [
    //     {
    //       validator: (rule, value, callback) => {
    //         // 验证不为空
    //         if (!value) {
    //           // this.$my_message('PQCP信息不全,请维护VAT!', 'error')
    //           this.$msg.error('PQCP信息不全,请维护对比供应物料&#!')
    //           return callback(new Error('Can not be Empty'));
    //         }
    //         callback();
    //       },
    //       trigger: "change"
    //     }
    //   ]);
    // },
    ingredientRules(index, row) {
      return (this.rules["ingredient"] = [
        {
          validator: (rule, value, callback) => {
            // 验证不为空
            if (!value) {
              // this.$my_message('PQCP信息不全,请维护VAT!', 'error')
              if (this.curOperation === 'Y') {
                this.$msg.error('PQCP信息不全,请维护' + this.tabIndex + '下的供应物料 Ingredient!')
              }
              return callback(new Error('Can not be Empty'));
            }
            callback();
          },
          trigger: "blur"
        }
      ]);
    },
    eightBitCodeNameRules(index, row) {
      return (this.rules["eightBitCodeName"] = [
        {
          validator: (rule, value, callback) => {
            // 验证不为空
            if (!value) {
              // this.$my_message('PQCP信息不全,请维护VAT!', 'error')
              if (this.curOperation === 'Y') {
                this.$msg.error('PQCP信息不全,请维护' + this.tabIndex + '下的对比物料 Ingredient!')
              }
              return callback(new Error('Can not be Empty'));
            }
            callback();
          },
          trigger: "blur"
        }
      ]);
    },
    newMenuItemNameRules(index, row) {
      return (this.rules["newMenuItemName"] = [
        {
          validator: (rule, value, callback) => {
            // 验证不为空
            if (!value) {
              // this.$my_message('PQCP信息不全,请维护VAT!', 'error')
              if (this.curOperation === 'Y') {
                this.$msg.error('PQCP信息不全,请维护' + this.tabIndex + '下的Menu Item!')
              }
              return callback(new Error('Can not be Empty'));
            }
            callback();
          },
          trigger: "blur"
        }
      ]);
    },
    purchaseForcastRules(index, row) {
      return (this.rules["purchaseForcast"] = [
        {
          validator: (rule, value, callback) => {
            // 验证不为空
            if (!value) {
              // this.$my_message('PQCP信息不全,请维护VAT!', 'error')
              if (this.curOperation === 'Y') {
                this.$msg.error('PQCP信息不全,请维护' + this.tabIndex + '下的Price per Case(wo VAT) !')
              }
              return callback(new Error('Can not be Empty'));
            }
            callback();
          },
          trigger: "blur"
        }
      ]);
    },
    totalEstimatedQtyRules(index, row) {
      return (this.rules["totalEstimatedQty"] = [
        {
          validator: (rule, value, callback) => {
            // 验证不为空
            if (!value) {
              // this.$my_message('PQCP信息不全,请维护VAT!', 'error')
              if (this.curOperation === 'Y') {
                this.$msg.error('PQCP信息不全,请维护' + this.tabIndex + '下的Total Estimated Qty(Case)!')
              }
              return callback(new Error('Can not be Empty'));
            }
            var reg = /^\d+$/
            if (!reg.test(value)) {
              this.$msg.error(this.tabIndex + '下的Total Estimated Qty(Case)请输入正整数或者0')
              return callback(new Error(' '));
            }
            callback();
          },
          trigger: "blur"
        }
      ]);
    },
    transportaionMethodRules(index, row) {
      return (this.rules["transportaionMethod"] = [
        {
          validator: (rule, value, callback) => {
            // 验证不为空
            if (!value) {
              // this.$my_message('PQCP信息不全,请维护VAT!', 'error')
              if (this.curOperation === 'Y') {
                this.$msg.error('PQCP信息不全,请维护' + this.tabIndex + '下的Delivery Type!')
              }
              return callback(new Error('Can not be Empty'));
            }
            callback();
          },
          trigger: "change"
        }
      ]);
    },
    freightRules(index, row) {
      return (this.rules["freight"] = [
        {
          validator: (rule, value, callback) => {
            // 验证不为空
            if (row.transportaionMethod != 'DC' && !value) {
              // this.$my_message('PQCP信息不全,请维护VAT!', 'error')
              if (this.curOperation === 'Y') {
                this.$msg.error('PQCP信息不全,请维护' + this.tabIndex + '下的Freight!')
              }
              return callback(new Error('Can not be Empty'));
            }
            callback();
          },
          trigger: "blur"
        }
      ]);
    },
    promotionDateFromRules(index, row) {
      return (this.rules["promotionDateFrom"] = [
        {
          validator: (rule, value, callback) => {
            // 验证不为空
            if (!value) {
              // this.$my_message('PQCP信息不全,请维护VAT!', 'error')
              if (this.curOperation === 'Y') {
                this.$msg.error('PQCP信息不全,请维护' + this.tabIndex + '下的Promotion Date From!')
              }
              return callback(new Error('Can not be Empty'));
            }
            callback();
          },
          trigger: "change"
        }
      ]);
    },
    promotionDateToRules(index, row) {
      return (this.rules["promotionDateTo"] = [
        {
          validator: (rule, value, callback) => {
            // 验证不为空
            if (!value) {
              // this.$my_message('PQCP信息不全,请维护VAT!', 'error')
              if (this.curOperation === 'Y') {
                this.$msg.error('PQCP信息不全,请维护' + this.tabIndex + '下的Promotion Date To!')
              }
              return callback(new Error('Can not be Empty'));
            }
            callback();
          },
          trigger: "change"
        }
      ]);
    },
    vatRules(index, row) {
      return (this.rules["vat"] = [
        {
          validator: (rule, value, callback) => {
            // 验证不为空
            if (!value) {
              // this.$my_message('PQCP信息不全,请维护VAT!', 'error')
              if (this.curOperation === 'Y') {
                this.$msg.error('PQCP信息不全,请维护' + this.tabIndex + '下的VAT!')
              }
              return callback(new Error('Can not be Empty'));
            }
            callback();
          },
          trigger: "change"
        }
      ]);
    },
    pricePerUnitRules(index, row) {
      return (this.rules["pricePerUnit"] = [
        {
          validator: (rule, value, callback) => {
            // 验证不为空
            if (!value) {
              // this.$my_message('PQCP信息不全,请维护Price per UNIT(RMB EXCL.VAT)!', 'error')
              if (this.curOperation === 'Y') {
                this.$msg.error('PQCP信息不全,请维护' + this.tabIndex + '下的Price per UNIT(RMB EXCL.VAT) Price!')
              }
              return callback(new Error('Can not be Empty'));
            }
            callback();
          },
          trigger: "blur"
        }
      ]);
    },
    unitRules(index, row) {
      return (this.rules["unit"] = [
        {
          validator: (rule, value, callback) => {
            // 验证不为空
            if (!value) {
              // this.$my_message('PQCP信息不全,请维护Unit!', 'error')
              if (this.curOperation === 'Y') {
                this.$msg.error('PQCP信息不全,请维护' + this.tabIndex + '下的Price per UNIT(RMB EXCL.VAT) Unit!')
              }
              return callback(new Error('Can not be Empty'));
            }
            callback();
          },
          trigger: "change"
        }
      ]);
    },
    pricePerUnitContrastRules(index, row) {
      return (this.rules["pricePerUnitContrast"] = [
        {
          validator: (rule, value, callback) => {
            // 验证不为空
            if (row.localItemContrast != 'NA' && !value) {
              // this.$my_message('PQCP信息不全,请维护对比物料Price per UNIT(RMB EXCL.VAT)!', 'error')
              if (this.curOperation === 'Y') {
                this.$msg.error('PQCP信息不全,请维护' + this.tabIndex + '下的对比物料Price per UNIT(RMB EXCL.VAT) Price!')
              }
              return callback(new Error('Can not be Empty'));
            }
            callback();
          },
          trigger: "blur"
        }
      ]);
    },
    unitContrastRules(index, row) {
      return (this.rules["unitContrast"] = [
        {
          validator: (rule, value, callback) => {
            // 验证不为空
            if (row.localItemContrast != 'NA' && !value) {
              // this.$my_message('PQCP信息不全,请维护Unit!', 'error')
              if (this.curOperation === 'Y') {
                this.$msg.error('PQCP信息不全,请维护' + this.tabIndex + '下的对比物料Price per UNIT(RMB EXCL.VAT) Unit!')
              }
              return callback(new Error('Can not be Empty'));
            }
            callback();
          },
          trigger: "change"
        }
      ]);
    },
    priceValidDateFromRules(index, row) {
      return (this.rules["priceValidDateFrom"] = [
        {
          validator: (rule, value, callback) => {
            // 验证不为空
            if (!value) {
              // this.$my_message('PQCP信息不全,请维护Price Valid Date From!', 'error')
              if (this.curOperation === 'Y') {
                this.$msg.error('PQCP信息不全,请维护' + this.tabIndex + '下的Price Valid Date From!')
              }
              return callback(new Error('Can not be Empty'));
            }
            callback();
          },
          trigger: "change"
        }
      ]);
    },
    priceValidDateToRules(index, row) {
      return (this.rules["priceValidDateTo"] = [
        {
          validator: (rule, value, callback) => {
            // 验证不为空
            if (!value) {
              // this.$my_message('PQCP信息不全,请维护Price Valid Date To!', 'error')
              if (this.curOperation === 'Y') {
                this.$msg.error('PQCP信息不全,请维护' + this.tabIndex + '下的Price Valid Date To!')
              }
              return callback(new Error('Can not be Empty'));
            }
            callback();
          },
          trigger: "change"
        }
      ]);
    },
    tradeTermRules(index, row) {
      return (this.rules["tradeTerm"] = [
        {
          validator: (rule, value, callback) => {
            // 验证不为空
            if (!value) {
              // this.$my_message('PQCP信息不全,请维护Trade Term!', 'error')
              if (this.curOperation === 'Y') {
                this.$msg.error('PQCP信息不全,请维护' + this.tabIndex + '下的Trade Term!')
              }
              return callback(new Error('Can not be Empty'));
            }
            callback();
          },
          trigger: "change"
        }
      ]);
    },
    remarkRules(index, row) {
      return (this.rules["remark"] = [
        {
          validator: (rule, value, callback) => {
            // 验证不为空
            if (!value) {
              // this.$my_message('PQCP信息不全,请维护Remark!', 'error')
              if (this.curOperation === 'Y') {
                this.$msg.error('PQCP信息不全,请维护' + this.tabIndex + '下的Remark!')
              }
              return callback(new Error('Can not be Empty'));
            }
            callback();
          },
          trigger: "blur"
        }
      ]);
    },
    packagingSizeRules(index, row) {
      return (this.rules["packagingSize"] = [
        {
          validator: (rule, value, callback) => {
            // 验证不为空
            if (!value) {
              // this.$my_message('PQCP信息不全,请维护Packing Size per CASE!', 'error')
              if (this.curOperation === 'Y') {
                this.$msg.error('PQCP信息不全,请维护' + this.tabIndex + '下的Packing Size per CASE!')
              }
              return callback(new Error('Can not be Empty'));
            }
            callback();
          },
          trigger: "blur"
        }
      ]);
    },
    packingSizePerCaseContrastRules(index, row) {
      return (this.rules["packingSizePerCaseContrast"] = [
        {
          validator: (rule, value, callback) => {
            // 验证不为空
            if (row.localItemContrast != 'NA' && !value) {
              // this.$my_message('PQCP信息不全,请维护对比物料Packing Size per CASE!', 'error')
              if (this.curOperation === 'Y') {
                this.$msg.error('PQCP信息不全,请维护' + this.tabIndex + '下的对比物料Packing Size per CASE!')
              }
              return callback(new Error('Can not be Empty'));
            }
            callback();
          },
          trigger: "blur"
        }
      ]);
    },
    netContentRules(index, row) {
      return (this.rules["netContent"] = [
        {
          validator: (rule, value, callback) => {
            // 验证不为空
            if (!value) {
              // this.$my_message('PQCP信息不全,请维护Net Content!', 'error')
              if (this.curOperation === 'Y') {
                this.$msg.error('PQCP信息不全,请维护' + this.tabIndex + '下的Net Content!')
              }
              return callback(new Error('Can not be Empty'));
            }
            callback();
          },
          trigger: "blur"
        }
      ]);
    },
    netContentContrastRules(index, row) {
      return (this.rules["netContentContrast"] = [
        {
          validator: (rule, value, callback) => {
            // 验证不为空
            if (row.localItemContrast != 'NA' && !value) {
              // this.$my_message('PQCP信息不全,请维护对比物料Net Content!', 'error')
              if (this.curOperation === 'Y') {
                this.$msg.error('PQCP信息不全,请维护' + this.tabIndex + '下的对比物料Net Content!')
              }
              return callback(new Error('Can not be Empty'));
            }
            callback();
          },
          trigger: "blur"
        }
      ]);
    },
    ssCategoryLeaderIdRules(index, row) {
      return (this.rules["ssCategoryLeaderId"] = [
        {
          validator: (rule, value, callback) => {
            console.log("🚀 ~ file: newCampaign.vue:1669 ~ ssCategoryLeaderIdRules ~ value:", value)
            // 验证不为空
            if (!value) {
              if (this.curOperation === 'Y') {
                this.$msg.error('PQCP信息不全,请维护' + this.tabIndex + '下的SS Category leader!')
              }
              // this.$my_message('PQCP信息不全,请维护SS Category leader!', 'error')
              return callback(new Error('Can not be Empty'));
            }
            callback();
          },
          trigger: "change"
        }
      ]);
    },
    nfcCategoryLeaderIdRules(index, row) {
      return (this.rules["nfcCategoryLeaderId"] = [
        {
          validator: (rule, value, callback) => {
            // 验证不为空
            if (!value) {
              if (this.curOperation === 'Y') {
                this.$msg.error('PQCP信息不全,请维护' + this.tabIndex + '下的NFS审批人!')
              }
              // this.$my_message('PQCP信息不全,请维护审批人!', 'error')
              return callback(new Error('Can not be Empty'));
            }
            callback();
          },
          trigger: "change"
        }
      ]);
    },
    deliveryTypeChange(e, row) {
      console.log("🚀 ~ file: newCampaign.vue:1588 ~ deliveryTypeChange ~ e:", e)
      if (!e) {
        row.transportaionMethod = null
      }
      if (e == 'DC') {
        row.freight = '0.000000'
      }
      let totalCost = 0;
      let totalEstimatedAmount = 0;
      if (commonFun.isNotEmpty(row.purchaseForcast)) {
        totalCost = (row.purchaseForcast * 1).toFixed(6);
        if (commonFun.isNotEmpty(row.totalEstimatedQty)) {
          // Total Estimated Amount (RMB)=Total Estimated Qty(Case)* Total Cost(without VAT)
          totalEstimatedAmount = row.totalEstimatedQty * totalCost;
        }
      }
      this.$set(row, "totalCost", totalCost);
      this.$set(row, "totalEstimatedAmount", totalEstimatedAmount);
    },
    changeSsFeedbackHour() {
      if (commonFun.isNotEmpty(this.formData.ssFeedbackHour)) {
        // this.$set(this.formData, "ssFeedbackDeadline", moment().add(this.formData.ssFeedbackHour, 'hour').format("YYYY-MM-DD HH:mm:ss"));
        this.$set(this.formData, "ssFeedbackDeadline", null);
      } else {
        this.$set(this.formData, "ssFeedbackDeadline", null);
      }
    },
    saveMarks() {
      fpaLtoCampaignApi.saveMarks(this.formData).then(res => {
        if (res && res.code == 200) {
          Message.success(this.$t("common.operateSuccess"));
        }
      })
    },
    //下拉列表数据获取
    getInputChoiceValues() {
      let mapObj = {};
      mapObj["TT_FPA:QUERY_STATUS"] = "TT_FPA:QUERY_STATUS";
      mapObj["TT_FPA_LTO_CAMPAIGN:PURPOSE_AGREEMENT"] = "TT_FPA_LTO_CAMPAIGN:PURPOSE_AGREEMENT";
      mapObj["TM_MATERIAL_RECORD:PRICE_TYPE"] = "TM_MATERIAL_RECORD:PRICE_TYPE";
      mapObj["TM_MATERIAL_RECORD:MINIMUM_ORDER_UNIT"] = "TM_MATERIAL_RECORD:MINIMUM_ORDER_UNIT";
      mapObj["TM_MATERIAL_RECORD:URCHASE_TAX_RATE"] = "TM_MATERIAL_RECORD:URCHASE_TAX_RATE";
      mapObj["TM_MATERIAL:DIS_TYPE"] = "TM_MATERIAL:DIS_TYPE";
      mapObj["TM_FIVE_BIT_CODE:UOM"] = "TM_FIVE_BIT_CODE:UOM";//计量单位
      mapObj["TM_MATERIAL_RECORD:PRODUCT_PACKAGING_TYPE"] = "TM_MATERIAL_RECORD:PRODUCT_PACKAGING_TYPE";//产品外包装类型
      mapObj["TM_MATERIAL_RECORD:INNER_PACKING_TYPE"] = "TM_MATERIAL_RECORD:INNER_PACKING_TYPE";//产品内包装类型
      inputChoiceService.getInputChoiceValues(mapObj).then((res) => {
        this.queryStatusList = res["TT_FPA:QUERY_STATUS"];
        this.agreementPurposeList = res["TT_FPA_LTO_CAMPAIGN:PURPOSE_AGREEMENT"];
        this.priceTypeList = res["TM_MATERIAL_RECORD:PRICE_TYPE"];
        this.uomList = res["TM_MATERIAL_RECORD:MINIMUM_ORDER_UNIT"];
        this.pqcnVatRateList = res["TM_MATERIAL_RECORD:URCHASE_TAX_RATE"];
        this.newTransportaionMethodList = res["TM_MATERIAL:DIS_TYPE"];
        this.unitLists = res["TM_FIVE_BIT_CODE:UOM"];//计量单位
        this.innerPackingTypeLists = res["TM_MATERIAL_RECORD:INNER_PACKING_TYPE"];//产品内包装类型
        this.productPackagingTypeLists = res["TM_MATERIAL_RECORD:PRODUCT_PACKAGING_TYPE"];//产品外包装类型
      });
    },
    getCategoryLeader() {
      let data = {
        type: 'SS'
      }
      fpaLtoCampaignApi.getCategoryLeader(data).then(res => {
        if (res.code == '200') {
          this.ssCategoryLeaderList = res.data;
        }
      });
      data = {
        type: 'NFC'
      }
      fpaLtoCampaignApi.getCategoryLeader(data).then(res => {
        if (res.code == '200') {
          this.nfcCategoryLeaderList = res.data;
        }
      });
    },
    fpaLtoCampaignDetail() {
      this.showAll = false;
      this.nfcAdminSubmit = false;
      this.canUpdate = false;
      this.isOwner = false;
      this.canMenuVpApprove = false;
      this.canScmVpApprove = false;
      this.canCfoVpApprove = false;
      this.canCeoApprove = false;
      this.canCgoApprove = false;
      this.canDownload = false;
      this.estimateVolumeOfPurchaseUpdate = false;
      var ownerLists = []
      fpaLtoCampaignApi.fpaLtoCampaignDetail(this.formData.ttFpaLtoCampaignId).then((res) => {
        res.data.fpaLtoPqcnList.forEach(pqcn => {
          this.$set(pqcn, 'isValid', 'Y')
          ownerLists.push(pqcn.owner)
          if (commonFun.isNotEmpty(pqcn.dcs)) {
            pqcn.dcIdList = pqcn.dcs.split(",");
          } else {
            pqcn.dcIdList = [];
          }
        })
        console.log("🚀 ~ file: newCampaign.vue:734 ~ fpaLtoCampaignApi.fpaLtoCampaignDetail ~ ownerLists:", ownerLists)
        this.formData = res.data;
        if (!this.formData.otherNfsPqcnList) {
          this.formData.otherNfsPqcnList = []
        }
        console.log("🚀 ~ file: newCampaign.vue:1500 ~ fpaLtoCampaignApi.fpaLtoCampaignDetail ~ this.formData:", this.formData)
        this.nfsLists = []
        this.childTabs = []
        res.data.nfsList.forEach(ele => {
          this.nfsLists.push({
            tmUserId: ele.tmUserId,
            name: ele.userName
          })
          this.childTabs.push({
            tmUserId: ele.tmUserId,
            name: ele.userName,
            lists: []
          })
          // if (ownerLists.includes(ele.tmUserId)) {
          //   this.childTabs.push({
          //     tmUserId: ele.tmUserId,
          //     name: ele.userName,
          //     lists: []
          //   })
          // }
        })
        if (res.data.fpaLtoPqcnList.length > 0) {
          for (let i = 0; i < res.data.fpaLtoPqcnList.length; i++) {
            for (let j = 0; j < this.childTabs.length; j++) {
              if (res.data.fpaLtoPqcnList[i].owner === this.childTabs[j].tmUserId) {
                this.childTabs[j].lists.push(res.data.fpaLtoPqcnList[i]);
                break;
              }
            }
          }
        }
        console.log('this.childTabs', this.childTabs)
        this.formData.notionalValueOfAgreement = (res.data.notionalValueOfAgreement + '').replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
        let ms_roles = localStorage.getItem("ms_roles");
        let nfcAdmin = false;
        if (localStorage.getItem("ms_userId") == this.formData.createBy) {
          this.isOwner = true;
        } else {
          this.isOwner = false
        }
        if (ms_roles != null) {
          ms_roles = JSON.parse(ms_roles);
          if (ms_roles.indexOf('NFC_ADMIN') != -1) {
            nfcAdmin = true;
          }
        }
        if (this.formData.status != 'new') {
          this.showAll = true;
        }
        if (this.formData.status == 'new' && nfcAdmin) {
          this.canUpdate = true;
        }

        if ((this.formData.status == 'nfcApproved' || this.formData.status == 'reject') && this.isOwner) {
          this.nfcAdminSubmit = true;
          this.estimateVolumeOfPurchaseUpdate = true;
        }

        if (ms_roles != null) {
          ms_roles = JSON.parse(localStorage.getItem("ms_roles"));
          if (ms_roles.indexOf('Menu_VP') != -1 && this.formData.status == 'menuVpApproving') {
            this.canMenuVpApprove = true;
          } else if (ms_roles.indexOf('SCM_VP') != -1 && this.formData.status == 'scmVpApproving') {
            this.canScmVpApprove = true;
          } else if (ms_roles.indexOf('CFO') != -1 && this.formData.status == 'CFOApproving') {
            this.canCfoVpApprove = true;
          } else if (ms_roles.indexOf('CEO') != -1 && this.formData.status == 'CEOApproving') {
            this.canCeoApprove = true;
          } else if(ms_roles.indexOf('CGO')!=-1 && this.formData.status == 'CGOApproving') {
            this.canCgoApprove = true;
          }
          if (ms_roles.indexOf('Menu_VP') != -1 || ms_roles.indexOf('HeadofMenuSolution') != -1 || ms_roles.indexOf('SCM_VP') != -1
            || ms_roles.indexOf('CFO') != -1 || ms_roles.indexOf('CEO') != -1 || ms_roles.indexOf('CGO') != -1) {
            this.attachmentView = true;
          }
        }
        if ((this.attachmentView || this.isOwner)
          && this.formData.status != 'new' && this.formData.status != 'nfcApproving') {
          this.canDownload = true;
        }

        const roles = localStorage.getItem("ms_roles");
        if (this.formData.status != 'new' && (roles.indexOf("MDM_TEAM") != -1 || roles.indexOf("MDM_ADMIN") != -1)) {
          this.canDownload = true;
        }
        // if(this.canDownload && this.nfcAdminSubmit) {
        //   this.attachmentList.push({
        //     type: "Other Document",
        //     documentName: ""
        //   })
        // }
        this.$forceUpdate();
        fileService.getFileList({seq:"NFSC",tsRecId: this.ttFpaLtoCampaignId,tsReckindId:"FPA_LTO_CAMPAIGN"}).then(res => {
          let otherAttachmentList = res?res:[];
          if(otherAttachmentList.length > 0) {
            this.attachmentList =  [
              {
                type: "System Document",
                documentName: "Download by PDF"
              }
            ];
            otherAttachmentList.forEach((attachment, index) => {
              this.attachmentList.push({
                type: "Other Document",
                documentName: attachment.documentName,
                fullPath: attachment.fullPath,
                tmDocumentId: attachment.tmDocumentId
              })
            })
          }
        })
      });
    },
    attachmentUpload() {
      this.showFileUpload = true;
      this.fileUploadDisabled = false;
    },
    attachmentDownload(row) {
      if(row.type === "System Document") {
        fpaLtoCampaignApi.fpaPdfDownload(this.formData).then(res => {
          fileService.respToFile(res, 'Fpa_lto_Campaign.pdf');
        });
      } else {
        fileService.downloadFile(row).then(res => {

        })
      }
    },
    validateDetailsUploaded(fpaLtoPqcnList) {
      for (let i = 0; i < (fpaLtoPqcnList || []).length; i++) {
        if (commonFun.isEmpty(fpaLtoPqcnList[i].purchaseForcast)) {
          // this.$message.error(this.$t('fpaManage.ltoCampaign.uploadDetailsCheck', [i + 1]));
          this.$msg.error(this.$t('fpaManage.ltoCampaign.uploadDetailsCheck', [i + 1]))
          return false;
        }
      }
      return true;
    },
    // 上传附件
    uploadOtherDoc(row, index) {
      this.localItemShowFileUpload = true
    },
    // 删除附件
    delOtherDoc(row, index) {
      console.log(row)
      if(row.tmDocumentId) {
        fileService.deleteFile(row.tmDocumentId).then(res => {
          if(res.code == 200) {
            this.attachmentList.splice(index, 1);
          }
        })
      } else {
        this.attachmentList.splice(index, 1);
      }
    },
    // 新增附件
    addOtherDoc() {
      this.attachmentList.push({
        type: "Other Document",
        documentName: ""
      })
    },
    onSelNfs() {
      console.log('nfsRef', this.$refs.nfsRef)
      this.nfsDialog = true
      this.index += 1
      this.nfsArr = JSON.stringify(this.nfsLists)
      // this.$refs.nfsRef.$refs.pickUserTable.clearSelection();
    },
    dcsChange(row, e) {
      console.log("🚀 ~ file: newCampaign.vue:1955 ~ dcsChange ~ e:", e)
      console.log("🚀 ~ file: newCampaign.vue:1955 ~ dcsChange ~ row:", row)
      if (e.length == 0) {
        row.dcs = null
      }
    },
    fpaLtoCampaignSave() {
      this.isFirstLoad = false
      this.curOperation = 'N'
      if (this.formData.status != 'new') {
        let validFlag = true;
        let that = this;
        if (commonFun.isNotEmpty(this.formData.fpaLtoPqcnList)) {
          this.formData.fpaLtoPqcnList.forEach(fpaLtoPqcn => {
            if (commonFun.isEmpty(fpaLtoPqcn.tmSupplierId)) {
              // that.$message.error(that.$t('fpaManage.ltoCampaign.canNotFindMaterial', [fpaLtoPqcn.localItem]));
              this.$msg.error(that.$t('fpaManage.ltoCampaign.canNotFindMaterial', [fpaLtoPqcn.localItem]))
              validFlag = false;
              return false;
            }
            if (commonFun.isNotEmpty(fpaLtoPqcn.dcIdList)) {
              fpaLtoPqcn.dcs = fpaLtoPqcn.dcIdList.join(",");
            }
          })
        }
        if (!validFlag) {
          return;
        }
        var str = [
          {
            prop: this.formData.productOrCommodityPurchased,
            label: "Product or Commodity Purchased",
            format: ['validLengthThousand']
          },
          {
            prop: this.formData.riskIdentifiHedgeJustifi,
            label: "Risk Identification & Hedge Justification",
            format: ['validLengthThousand']
          },
        ]
        const h = this.$createElement
        var valid = this.utils.centralizedValid(str, h)
        console.log('校验结果', valid);
        if (!valid) {
          return false
        }
        this.formData.operateType = 'save';
        console.log("🚀 ~ file: newCampaign.vue:1078 ~ fpaLtoCampaignSave ~ this.formData:", this.formData)
        fpaLtoCampaignApi.fpaLtoCampaignSave(this.formData).then((res) => {
          if (res.data) {
            this.formData.ttFpaLtoCampaignId = res.data;
            this.fpaLtoCampaignDetail();
            // 路由跳转（没有点sidebar），需要手动触发菜单选中效果
            //this.$root.eventHub.$emit("onSelectItem", "/rfqManage");
          } else {
            // this.$message.error(res.msg || this.$t("common.operateError"));
            this.$msg.error(res.msg || this.$t("common.operateError"))
          }
        });
      } else {
        // 第一步校验header上的表单
        this.$refs['formData1'].validate((valid) => {
          if (valid) {
            var str = [
              {
                prop: this.formData.productOrCommodityPurchased,
                label: "Product or Commodity Purchased",
                format: ['validLengthThousand']
              },
              {
                prop: this.formData.riskIdentifiHedgeJustifi,
                label: "Risk Identification & Hedge Justification",
                format: ['validLengthThousand']
              },
            ]
            const h = this.$createElement
            var valid = this.utils.centralizedValid(str, h)
            console.log('校验结果', valid);
            if (!valid) {
              return false
            }
            // 第二步校验是否选择nfs
            if (this.nfsLists.length === 0) {
              // this.$message.error('请先维护NFS后再点击保存，谢谢。');
              this.$msg.error('请先维护NFS后再点击保存，谢谢。')
              return false
            }
            this.formData.nfsList = []
            this.nfsLists.forEach(ele => {
              this.formData.nfsList.push({
                tmUserId: ele.tmUserId
              })
            })
            console.log('this.childTabs', this.childTabs)
            let errorFlag = true;
            // 第三步,校验如果是单据创建者,则需要校验所有tab栏下的供应物料以及对比物料是否存在,以及supplier DC是否存在重复
            if (this.isOwner) {
              if (this.childTabs.length > 0) {
                for (let i = 0; i < this.childTabs.length; i++) {
                  const ele = this.childTabs[i];
                  if (ele.lists.length > 0) {
                    for (let row of ele.lists) {
                      // 供应物料
                      if (commonFun.isEmpty(row.tmSupplierId)) {
                        this.$msg.error(this.tabIndex + ' Tab下,' + this.$t('fpaManage.ltoCampaign.canNotFindMaterial', [row.localItem]))
                        errorFlag = false;
                        return false;
                      }
                      // 对比物料
                      if (row.isValid !== 'Y') {
                        this.$msg.error(this.tabIndex + ' Tab下,' + this.$t('fpaManage.ltoCampaign.canNotFindMaterial1', [row.localItemContrast]))
                        errorFlag = false;
                        return false;
                      }
                    }
                    // var formName = 'ruleForm' + i
                    // console.log("单据创建者,获取每一个tab的ref-formName", formName)
                    // console.log("单据创建者,获取每一个tab的this.$refs[formName]", this.$refs[formName])
                    // this.tabIndex = this.childTabs[i].name
                    // console.log("单据创建者,当前报错属于哪个tab~ this.tabIndex:", this.tabIndex)
                    // this.$refs[formName][0].validate((valid) => {
                    //   console.log("🚀 ~ file: newCampaign.vue:2094 ~ this.$refs[formName][0].validate ~ valid:", valid)
                    //   if (!valid) {
                    //     errorFlag = false
                    //     return false;
                    //   }
                    // })
                    // if (!errorFlag) {
                    //   break
                    // }
                  }
                }
                console.log("🚀 ~ file: newCampaign.vue:2104 ~ this.$refs['formData1'].validate ~ errorFlag:", errorFlag)
                if (!errorFlag) {
                  return false;
                }
                var index = this.childTabs.findIndex(ele => {
                  return ele.tmUserId == this.ms_userId
                })
                if (index > -1) {
                  this.childTabs.forEach(ele => {
                    if (ele.tmUserId == this.ms_userId) {
                      this.formData.fpaLtoPqcnList = [...ele.lists]
                    } else {
                      this.formData.otherNfsPqcnList = this.formData.otherNfsPqcnList.concat(ele.lists)
                    }
                  })
                } else {
                  this.childTabs.forEach(ele => {
                    this.formData.otherNfsPqcnList = this.formData.otherNfsPqcnList.concat(ele.lists)
                  })
                  this.formData.fpaLtoPqcnList = []
                }
              }
            } else {
              // 第三步,校验如果是非创建者的nfs,需要校验自己tab下的供应物料和对比物料是否存在,以及supplier DC是否存在重复
              if (this.childTabs.length > 0) {
                var obj = this.childTabs.filter(ele => {
                  return ele.tmUserId == this.ms_userId
                })
                if (obj.length > 0) {
                  if (obj[0].lists.length > 0) {
                    obj[0].lists.forEach(fpaLtoPqcn => {
                      if (commonFun.isEmpty(fpaLtoPqcn.tmSupplierId)) {
                        this.$msg.error(this.tabIndex + ' Tab下,' + this.$t('fpaManage.ltoCampaign.canNotFindMaterial', [fpaLtoPqcn.localItem]))
                        errorFlag = false;
                        return false;
                      }
                      if (fpaLtoPqcn.isValid !== 'Y') {
                        this.$msg.error(this.tabIndex + ' Tab下,' + this.$t('fpaManage.ltoCampaign.canNotFindMaterial1', [fpaLtoPqcn.localItemContrast]))
                        errorFlag = false;
                        return false;
                      }
                      if (commonFun.isNotEmpty(fpaLtoPqcn.dcIdList)) {
                        fpaLtoPqcn.dcs = fpaLtoPqcn.dcIdList.join(",");
                      }
                    })
                  }
                }
                if (!errorFlag) {
                  return;
                }
                this.formData.otherNfsPqcnList = []
                var index = this.childTabs.findIndex(ele => {
                  return ele.tmUserId == this.ms_userId
                })
                console.log("🚀 ~ file: newCampaign.vue:1676 ~ index ~ index:", index)
                if (index > -1) {
                  // var formName = 'ruleForm' + index
                  // console.log("🚀 ~ file: newCampaign.vue:1677 ~ fpaLtoCampaignSave ~ formName:", formName)
                  // console.log("this.$refs[formName]", this.$refs[formName])
                  // this.tabIndex = this.childTabs[index].name
                  // console.log("单据创建者,当前报错属于哪个tab~ this.tabIndex:", this.tabIndex)
                  // this.$refs[formName][0].validate((valid) => {
                  //   console.log("🚀 ~ file: newCampaign.vue:1670 ~ this.$refs['formData3'].validate ~ valid:", valid)
                  //   if (!valid) {
                  //     errorFlag = false;
                  //     return false;
                  //   }
                  // })
                  // console.log('"非创建者的nfs~errorFlag', errorFlag)
                  // if (!errorFlag) {
                  //   return;
                  // }
                  this.childTabs.forEach(ele => {
                    if (ele.tmUserId == this.ms_userId) {
                      this.formData.fpaLtoPqcnList = [...ele.lists]
                    } else {
                      this.formData.otherNfsPqcnList = this.formData.otherNfsPqcnList.concat(ele.lists)
                    }
                  })
                } else {
                  this.childTabs.forEach(ele => {
                    this.formData.otherNfsPqcnList = this.formData.otherNfsPqcnList.concat(ele.lists)
                  })
                  this.formData.fpaLtoPqcnList = []
                }
              }
            }

            this.childTabs.forEach(ele => {
              if (ele.lists.length > 0) {
                ele.lists.forEach(item => {
                  if (commonFun.isNotEmpty(item.dcIdList)) {
                    item.dcs = item.dcIdList.join(",");
                  }
                })
              }
            })
            this.formData.operateType = 'save';
            console.log("🚀 ~ file: newCampaign.vue:1078 ~ fpaLtoCampaignSave ~ this.formData:", this.formData)
            fpaLtoCampaignApi.fpaLtoCampaignSave(this.formData).then((res) => {
              if (res.data) {
                this.formData.ttFpaLtoCampaignId = res.data;
                this.fpaLtoCampaignDetail();
                // 路由跳转（没有点sidebar），需要手动触发菜单选中效果
                //this.$root.eventHub.$emit("onSelectItem", "/rfqManage");
                this.$msg.success(res.msg);
              } else {
                this.$msg.error(res.msg || this.$t("common.operateError"))
              }
            });
          }
        })
      }
    },
    fpaLtoCampaignSubmit() {
      console.log('提交this.formData.fpaLtoPqcnList', this.formData.fpaLtoPqcnList)
      this.curOperation = "Y"//判断当前操作是提交还是保存,提交时才做校验
      // 第一步校验header上的表单
      this.$refs['formData1'].validate((valid) => {
        if (valid) {
          var str = [
            {
              prop: this.formData.productOrCommodityPurchased,
              label: "Product or Commodity Purchased",
              format: ['validLengthThousand']
            },
            {
              prop: this.formData.riskIdentifiHedgeJustifi,
              label: "Risk Identification & Hedge Justification",
              format: ['validLengthThousand']
            },
          ]
          const h = this.$createElement
          var valid = this.utils.centralizedValid(str, h)
          console.log('header上的表单校验结果', valid);
          if (!valid) {
            return false
          }
          // 第二步,校验PQCP是否有数据
          var isArr = this.childTabs.every(ele => {
            return ele.lists.length === 0
          })
          if (commonFun.isEmpty(this.formData.fpaLtoPqcnList) && isArr) {
            //请先维护物料信息
            // this.$message.error(this.$t('fpaManage.ltoCampaign.pleaseMaintainPQCP'));
            this.$msg.error(this.$t('fpaManage.ltoCampaign.pleaseMaintainPQCP'))
            return;
          } else if (!this.validateDetailsUploaded(this.formData.fpaLtoPqcnList)) {
            // 行项目{0}：请先下载Excel附件，完善信息后上传，再点击提交！
            return;
          } else {
            console.log('提交时this.childTabs', this.childTabs)
            console.log('提交时this.isOwner', this.isOwner)
            let errorFlag = true;
            // 第三步,校验如果是单据创建者,则需要校验所有tab栏下的供应物料以及对比物料是否存在,以及supplier DC是否存在重复
            if (this.isOwner) {
              for (let i = 0; i < this.childTabs.length; i++) {
                const ele = this.childTabs[i];
                this.tabIndex = this.childTabs[i].name
                console.log("单据创建者,当前报错属于哪个tab~ this.tabIndex:", this.tabIndex)
                for (let row of ele.lists) {
                  // 供应物料
                  if (commonFun.isEmpty(row.tmSupplierId)) {
                    this.$msg.error(this.tabIndex + ' Tab下,' + this.$t('fpaManage.ltoCampaign.canNotFindMaterial', [row.localItem]))
                    errorFlag = false;
                    return false;
                  }
                  // 对比物料
                  if (row.isValid !== 'Y') {
                    this.$msg.error(this.tabIndex + ' Tab下,' + this.$t('fpaManage.ltoCampaign.canNotFindMaterial1', [row.localItemContrast]))
                    errorFlag = false;
                    return false;
                  }
                  console.log('materialDcs11', materialDcs)
                  // Supplied DC
                  let materialDcs = {};
                  for (let dcId of row.dcIdList) {
                    if (materialDcs[row.localItem + dcId]) {
                      this.$msg.error(this.tabIndex + ' Tab下,' + `Local Item:${row.localItem} Duplicate DC exits.`)
                      errorFlag = false;
                      return false;
                    } else {
                      materialDcs[row.localItem + dcId] = true;
                    }
                  }
                  console.log('materialDcs', materialDcs)
                }
                var formName = 'ruleForm' + i
                console.log("单据创建者,获取每一个tab的ref-formName", formName)
                console.log("单据创建者,获取每一个tab的this.$refs[formName]", this.$refs[formName])
                this.$refs[formName][0].validate((valid) => {
                  console.log("🚀 ~ file: newCampaign.vue:2094 ~ this.$refs[formName][0].validate ~ valid:", valid)
                  if (!valid) {
                    errorFlag = false
                    return false;
                  }
                })
                if (!errorFlag) {
                  break
                }
              }
              console.log("🚀 ~ file: newCampaign.vue:2104 ~ this.$refs['formData1'].validate ~ errorFlag:", errorFlag)
              if (!errorFlag) {
                return false;
              }
              this.childTabs.forEach(ele => {
                // this.formData.otherNfsPqcnList = this.formData.otherNfsPqcnList.concat(ele.lists)
                if (ele.lists.length > 0) {
                  ele.lists.forEach(item => {
                    if (commonFun.isNotEmpty(item.dcIdList)) {
                      item.dcs = item.dcIdList.join(",");
                    }
                  })
                }
              })
              this.formData.fpaLtoPqcnList = []
            } else {
              // 第三步,校验如果是非创建者的nfs,需要校验自己tab下的供应物料和对比物料是否存在,以及supplier DC是否存在重复
              var obj = this.childTabs.filter(ele => {
                return ele.tmUserId == this.ms_userId
              })
              console.log("非创建者的nfs找到对应的tab~ obj:", obj)
              var index = this.childTabs.findIndex(ele => {
                return ele.tmUserId == this.ms_userId
              })
              console.log("非创建者的nfs找到对应的tab~ index ~ index:", index)
              if (obj.length > 0) {
                if (obj[0].lists.length > 0) {
                  // let errorFlag = true;
                  for (let row of obj[0].lists) {
                    if (commonFun.isEmpty(row.tmSupplierId)) {
                      this.$msg.error(this.$t('fpaManage.ltoCampaign.canNotFindMaterial', [row.localItem]))
                      // that.$message.error(that.$t('fpaManage.ltoCampaign.canNotFindMaterial', [fpaLtoPqcn.localItem]));
                      errorFlag = false;
                      return false;
                    }
                    if (row.isValid !== 'Y') {
                      this.$msg.error(this.$t('fpaManage.ltoCampaign.canNotFindMaterial1', [row.localItemContrast]))
                      errorFlag = false;
                      return false;
                    }
                    // Supplied DC
                    let materialDcs = {};
                    for (let dcId of row.dcIdList) {
                      if (materialDcs[row.localItem + dcId]) {
                        // this.$message.error(`Local Item:${row.localItem} Duplicate DC exits.`);
                        this.$msg.error(`Local Item:${row.localItem} Duplicate DC exits.`)
                        errorFlag = false;
                        return false;
                      } else {
                        materialDcs[row.localItem + dcId] = true;
                      }
                    }
                    console.log('materialDcs', materialDcs)
                  }
                  if (!errorFlag) {
                    return;
                  }
                  obj[0].lists.forEach(pqcn => {
                    if (commonFun.isNotEmpty(pqcn.dcIdList)) {
                      pqcn.dcs = pqcn.dcIdList.join(",");
                    }
                  })
                }
              }
              if (index > -1) {
                var formName = 'ruleForm' + index
                console.log("非创建者的nfs~ formName:", formName)
                console.log("非创建者的nfs~this.$refs[formName]", this.$refs[formName])
                this.tabIndex = this.childTabs[index].name
                console.log("单据创建者,当前报错属于哪个tab~ this.tabIndex:", this.tabIndex)
                this.$refs[formName][0].validate((valid) => {
                  console.log("🚀 ~ file: newCampaign.vue:2166 ~ this.$refs[formName][0].validate ~ valid:", valid)
                  if (!valid) {
                    errorFlag = false;
                    return false;
                  }
                })
                console.log('"非创建者的nfs~errorFlag', errorFlag)
                if (!errorFlag) {
                  return;
                }
                // this.childTabs.forEach(ele => {
                //   if (ele.tmUserId == this.ms_userId) {
                //     this.formData.fpaLtoPqcnList = [...ele.lists]
                //   } else {
                //     this.formData.otherNfsPqcnList = this.formData.otherNfsPqcnList.concat(ele.lists)
                //   }
                // })
              } else {
                // this.childTabs.forEach(ele => {
                //   this.formData.otherNfsPqcnList = this.formData.otherNfsPqcnList.concat(ele.lists)
                // })
                // this.formData.fpaLtoPqcnList = []
              }
            }
          }
          // 第四步,校验是否存在nfs未维护
          var isFlag = this.childTabs.some(ele => {
            return ele.lists.length === 0
          })
          if (isFlag) {
            this.$msg.error('存在NFS未维护信息，请告知其进行维护或者删除此NFC Category Leader后再提交；谢谢。')
            return false
          }
          // 第五步,如果是非草稿状态的,则校验PQCP表格
          var isValidate
          if (this.formData.status != 'new') {
            this.$refs['formData2'].validate((valid1) => {
              if (valid1) {
                isValidate = true
              } else {
                isValidate = false
              }
            })
            console.log('如果是非草稿状态的,则校验PQCP表格-isValidate', isValidate)
            if (!isValidate) {
              return;
            }
          } else {
            // var index = this.childTabs.findIndex(ele => {
            //   return ele.tmUserId == this.ms_userId
            // })
            // console.log("🚀 ~ file: newCampaign.vue:1676 ~ index ~ index:", index)
            // if (index > -1 && !this.isOwner) {
            //   var formName = 'ruleForm' + index
            //   console.log("🚀 ~ file: newCampaign.vue:1677 ~ fpaLtoCampaignSave ~ formName:", formName)
            //   console.log("this.$refs[formName]", this.$refs[formName])
            //   this.$refs[formName][0].validate((valid) => {
            //     console.log("🚀 ~ file: newCampaign.vue:1670 ~ this.$refs['formData3'].validate ~ valid:", valid)
            //     if (valid) {
            //       isValidate = true
            //     } else {
            //       isValidate = false
            //     }
            //   })
            //   console.log('isValidate', isValidate)
            //   if (!isValidate) {
            //     return;
            //   }
            // }
          }
          // this.$refs['formData2'].validate((valid1) => {
          //   if (valid1) {
          this.formData.operateType = 'submit';
          //您确定要提交吗？
          this.$confirm('Would you like to submit this document!', 'Tips', {
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            customClass: 'colorBtn',
            cancelButtonClass: 'btn_custom_cancel',
            type: 'warning'
          }).then(() => {
            if (this.childTabs.findIndex(ele => {
              return ele.tmUserId == this.ms_userId
            }) > -1) {
              this.formData.fpaLtoPqcnList = []
              this.childTabs.forEach(ele => {
                if (ele.tmUserId == this.ms_userId) {
                  this.formData.fpaLtoPqcnList = [...ele.lists]
                } else {
                  this.formData.otherNfsPqcnList = this.formData.otherNfsPqcnList.concat(ele.lists)
                }
              })
            } else {
              if (this.isOwner) {
                this.childTabs.forEach(ele => {
                  this.formData.otherNfsPqcnList = this.formData.otherNfsPqcnList.concat(ele.lists)
                })
                this.formData.fpaLtoPqcnList = []
              }
            }
            fpaLtoCampaignApi.fpaLtoCampaignSave(this.formData).then((res) => {
              console.log("🚀 ~ file: newCampaign.vue:2060 ~ fpaLtoCampaignApi.fpaLtoCampaignSave ~ res:", res)
              this.curOperation = 'N'
              if (res.code == '200') {
                this.formData.ttFpaLtoCampaignId = res.data;
                this.fpaLtoCampaignDetail();
                // 路由跳转（没有点sidebar），需要手动触发菜单选中效果
                //this.$root.eventHub.$emit("onSelectItem", "/rfqManage");
                this.$msg.success(res.msg)
              } else {
                // this.$message.error(res.msg || this.$t("common.operateError"));
                this.$msg.error(res.msg || this.$t("common.operateError"))
              }
            }).catch((error) => {
              console.log("🚀 ~ file: newCampaign.vue:2072 ~ fpaLtoCampaignApi.fpaLtoCampaignSave ~ error:", error.response)
              this.curOperation = 'N'
              this.formData.operateType = 'save';
              fpaLtoCampaignApi.fpaLtoCampaignSave(this.formData).then((res) => {
                if (res.data) {
                  this.formData.ttFpaLtoCampaignId = res.data;
                  this.fpaLtoCampaignDetail();
                  // 路由跳转（没有点sidebar），需要手动触发菜单选中效果
                  //this.$root.eventHub.$emit("onSelectItem", "/rfqManage");
                } else {
                  // this.$message.error(res.msg || this.$t("common.operateError"));
                  this.$msg.error(res.msg || this.$t("common.operateError"))
                }
              });
              // this.fpaLtoCampaignDetail();
            })
          }).catch((err) => {
            // this.$message.info('已取消提交')
            this.$msg.info('已取消提交')
            // this.fpaLtoCampaignDetail();
          })
          // }
          // })
        }
      })
    },
    fpaLtoCampaignApprove(operateType) {
      if ("approving" == operateType) {
        this.dialogTitle = 'Approve'
        this.formData.auditResult = 'Y'
        this.showAuditPage = true;
      } else if ("reject" == operateType) {
        this.dialogTitle = 'Reject'
        this.formData.auditResult = 'N'
        this.showAuditPage = true;
      }
    },
    fpaLtoCampaignApproveConfirm() {
      this.formData.operateType = 'confirm';
      if (this.formData.auditResult == 'N' && commonFun.isEmpty(this.formData.auditRemark)) {
        //退回时备注不能为空
        // this.$message.error(this.$t('fpaManage.permanent.pleaseInputAuditRemark'))
        this.$msg.error(this.$t('fpaManage.permanent.pleaseInputAuditRemark'))
        return false;
      }
      //您确定要提交吗？
      this.$confirm('Would you like to submit this document!', 'Tips', {
        cancelButtonText: 'Cancel',
        confirmButtonText: 'Confirm',
        customClass: 'colorBtn',
        cancelButtonClass: 'btn_custom_cancel',
        type: 'warning'
      }).then(() => {
        if ('menuVpApproving' == this.formData.status) {
          fpaLtoCampaignApi.fpaLtoMenuVpApprove(this.formData).then((res) => {
            this.finishRouterBack(res);
          });
        } else if ('scmVpApproving' == this.formData.status) {
          fpaLtoCampaignApi.fpaLtoScmVpApprove(this.formData).then((res) => {
            this.finishRouterBack(res);
          });
        } else if ('CFOApproving' == this.formData.status) {
          fpaLtoCampaignApi.fpaLtoCfoApprove(this.formData).then((res) => {
            this.finishRouterBack(res);
          });
        } else if ('CEOApproving' == this.formData.status) {
          fpaLtoCampaignApi.fpaLtoCeoApprove(this.formData).then((res) => {
            this.finishRouterBack(res);
          });
        } else if('CGOApproving' == this.formData.status) {
          fpaLtoCampaignApi.fpaLtoCgoApprove(this.formData).then((res) => {
            this.finishRouterBack(res);
          });
        } else {
          fpaLtoCampaignApi.audit(this.formData).then((res) => {
            this.finishRouterBack(res);
          });
        }
        this.showAuditPage = false;
      })
    },
    finishRouterBack(res) {
      if (res.data) {
        this.routerBack();
      } else {
        // this.$message.error(res.msg || this.$t("common.operateError"));
        this.$msg.error(res.msg || this.$t("common.operateError"))
      }
    },
    fpaNfcAdminSubmit() {
      this.$refs.formData1.validate(valid => {
        if(valid) {
          if (this.checkData()) {
            //您确定要提交吗？
            this.$confirm('Would you like to submit this document!', 'Tips', {
              confirmButtonText: 'Confirm',
              cancelButtonText: 'Cancel',
              customClass: 'colorBtn',
              cancelButtonClass: 'btn_custom_cancel',
              type: 'warning'
            }).then(() => {
              fpaLtoCampaignApi.nfcAdminSubmit(this.formData).then((res) => {
                this.finishRouterBack(res);
              });
            })
          }
        } else {
          this.$message.error("LTO Material Information 未填写完整")
        }
      })
    },
    //SupplierCoverageList选择操作
    handleSupplierCoverageChange: function (row) {
      this.fpaSupplierCoverageSelect = row;
    },
    uploadTemplateConfirm: function (item) {
      let _this = this;
      let formData = new FormData();
      formData.append("file", item.file);
      request({
        url: "fpaLtoCampaign/pqcnImport",
        method: 'POST',
        data: formData,
      }).then((res) => {
        console.log("🚀 ~ file: newCampaign.vue:1914 ~ res:", res)
        if (res && res.code == 200) {
          //上传完成后执行清空
          var obj = this.childTabs.filter(ele => {
            return ele.tmUserId == this.ms_userId
          })
          res.data.forEach(pqcn => {
            pqcn.totalEstimatedAmount = parseFloat(pqcn.totalEstimatedAmount).toFixed(6);
            pqcn.isValid = 'Y'
            if (commonFun.isNotEmpty(obj[0].lists)) {
              if (obj[0].lists.filter(tmp => tmp.localItem == pqcn.localItem).length > 0) {
                pqcn.nfcCategoryLeaderId = obj[0].lists.filter(tmp => tmp.localItem == pqcn.localItem)[0].nfcCategoryLeaderId;
                pqcn.ssCategoryLeaderId = obj[0].lists.filter(tmp => tmp.localItem == pqcn.localItem)[0].ssCategoryLeaderId;
              }
            }
          });
          // this.formData.fpaLtoPqcnList = res.data;
          this.childTabs[this.selName].lists = res.data
          this.$forceUpdate();
        } else if (res && res.code == 500) {
          _this.$message.error({
            message: res.msg,
            duration: 100000,
            showClose: true,
            dangerouslyUseHTMLString: true
          })
        }
        var ref = 'upload' + this.selName
        if (this.$refs[ref][0]) {
          this.$refs[ref][0].clearFiles();
        }
      }).catch((error) => {
        console.log(error.msg);
        //上传执行清空
        var ref = 'upload' + this.selName
        if (this.$refs[ref][0]) {
          this.$refs[ref][0].clearFiles();
        }
        // this.$message.error(this.$t(error.msg) || this.$t("common.fileUploadFailed"))
        this.$msg.error(this.$t(error.msg) || this.$t("common.fileUploadFailed"))
      });
    },
    uploadOtherDocConfirm: function (file, row) {
      console.log(file)
      if(row.tmDocumentId) {
        fileService.deleteFile(row.tmDocumentId).then(res => {
          if(res.code == 200) {
            this.$set(row, "documentName", "")
            this.$set(row, "fullPath", "")
            this.$set(row, "tmDocumentId", "")

            let _this = this;
            let formData = new FormData();
            formData.append("file", file.file);
            request({
              url: "/file/FPA_LTO_CAMPAIGN/NFSC/" + this.formData.ttFpaLtoCampaignId,
              method: 'POST',
              data: formData,
            }).then((res) => {
              if (res && res.code == 200) {
                //上传完成后执行清空
                this.$refs.upload.clearFiles();
                this.$set(row, "documentName", res.data[0]?res.data[0].documentName:"")
                this.$set(row, "fullPath", res.data[0]?res.data[0].fullPath:"")
                this.$set(row, "tmDocumentId", res.data[0]?res.data[0].tmDocumentId:"")
              } else if (res && res.code == 500) {
                _this.$message.error({
                  message: res.msg,
                  duration: 100000,
                  showClose: true,
                  dangerouslyUseHTMLString: true
                })
              }
            }).catch((error) => {
              this.$refs.upload.clearFiles();
              this.$msg.error(this.$t(error.msg) || this.$t("common.fileUploadFailed"))
            });
          }
        })
      } else {
        let _this = this;
        let formData = new FormData();
        formData.append("file", file.file);
        request({
          url: "/file/FPA_LTO_CAMPAIGN/NFSC/" + this.formData.ttFpaLtoCampaignId,
          method: 'POST',
          data: formData,
        }).then((res) => {
          if (res && res.code == 200) {
            //上传完成后执行清空
            this.$refs.upload.clearFiles();
            this.$set(row, "documentName", res.data[0]?res.data[0].documentName:"")
            this.$set(row, "fullPath", res.data[0]?res.data[0].fullPath:"")
            this.$set(row, "tmDocumentId", res.data[0]?res.data[0].tmDocumentId:"")
          } else if (res && res.code == 500) {
            _this.$message.error({
              message: res.msg,
              duration: 100000,
              showClose: true,
              dangerouslyUseHTMLString: true
            })
          }
        }).catch((error) => {
          this.$refs.upload.clearFiles();
          this.$msg.error(this.$t(error.msg) || this.$t("common.fileUploadFailed"))
        });
      }
    },
    uploadUpdateConfirm: function (item) {
      this.formData.fpaLtoPqcnList = [];
      let _this = this;
      let formData = new FormData();
      formData.append("file", item.file);
      formData.append("ttFpaLtoCampaignId", this.formData.ttFpaLtoCampaignId);
      request({
        url: "fpaLtoCampaign/pqcnUpdate",
        method: 'POST',
        data: formData,
      }).then((res) => {
        if (res && res.code == 200) {
          //上传完成后执行清空
          this.$refs.upload.clearFiles();
          this.formData.ttFpaLtoCampaignId = res.data;
          this.fpaLtoCampaignDetail();
        } else if (res && res.code == 500) {
          _this.$message.error({
            message: res.msg,
            duration: 100000,
            showClose: true,
            dangerouslyUseHTMLString: true
          })
        }
      }).catch((error) => {
        //上传执行清空
        this.$refs.upload.clearFiles();
        // this.$message.error(this.$t(error.msg) || this.$t("common.fileUploadFailed"))
        this.$msg.error(this.$t(error.msg) || this.$t("common.fileUploadFailed"))
      });
    },
    changeRowBgColorByIsLocal({ row, rowIndex }) {
      let stylejson = {};
      if (row.isLocal === '0') {
        stylejson.background = '#17b6e5';
      }
      return stylejson;
    },
    ltoPqcnRejectConfirm() {
      if (commonFun.isEmpty(this.formData.auditRemark)) {
        //退回时备注不能为空
        // this.$message.error(this.$t('fpaManage.permanent.pleaseInputAuditRemark'))
        this.$msg.error(this.$t('fpaManage.permanent.pleaseInputAuditRemark'))
        return false;
      }
      this.showRejectPage = false;
      this.formData.ttFpaLtoId = this.rejectFpaLtoId;
      //您确定要退回吗？
      this.$confirm('Would you like to submit this document!', 'Tips', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        customClass: 'colorBtn',
        cancelButtonClass: 'btn_custom_cancel',
        type: 'warning'
      }).then(() => {
        fpaLtoCampaignApi.fpaLtoReject(this.formData).then((res) => {
          if (res.data) {
            this.formData.ttFpaLtoCampaignId = res.data;
            this.fpaLtoCampaignDetail();
            // 路由跳转（没有点sidebar），需要手动触发菜单选中效果
            //this.$root.eventHub.$emit("onSelectItem", "/rfqManage");
          } else {
            // this.$message.error(res.msg || this.$t("common.operateError"));
            this.$msg.error(res.msg || this.$t("common.operateError"))
          }
        });
      })

    },
    ltoPqcnReject(ttFpaLtoId) {
      this.showRejectPage = true;
      this.rejectFpaLtoId = ttFpaLtoId;
    },
    countPqcp(row) {
      let totalCost = 0;
      let totalEstimatedAmount = 0;
      if (commonFun.isNotEmpty(row.purchaseForcast)) {
        if (commonFun.isNotEmpty(row.freight)) {
          this.$set(row, "freight", (row.freight * 1).toFixed(6));
          // Total Cost(without VAT)=freight+Price per Case(wo VAT) 
          totalCost = (row.freight * 1 + row.purchaseForcast * 1).toFixed(6);
        } else {
          totalCost = (row.purchaseForcast * 1).toFixed(6);
        }
        if (commonFun.isNotEmpty(row.totalEstimatedQty)) {
          // Total Estimated Amount (RMB)=Total Estimated Qty(Case)* Total Cost(without VAT)
          totalEstimatedAmount = row.totalEstimatedQty * totalCost;
        }
      }
      this.$set(row, "totalCost", totalCost);
      this.$set(row, "totalEstimatedAmount", totalEstimatedAmount);
    },
    setPurchaseForcast(row) {
      console.log("🚀 ~ file: newCampaign.vue:2722 ~ setPurchaseForcast ~ row:", row)
      if (commonFun.isNotEmpty(row.purchaseForcast)) {
        let reg = /^\d+(\.\d+)?$/
        if (!reg.test(row.purchaseForcast)) {
          this.$set(row, "purchaseForcast", '');
        } else {
          this.$set(row, "purchaseForcast", (row.purchaseForcast * 1).toFixed(6));
        }
        let totalCost = 0;
        let totalEstimatedAmount = 0;
        let price = 0;
        let externalPackagingNetweight = 0;
        if (commonFun.isNotEmpty(row.purchaseForcast)) {
          if (commonFun.isNotEmpty(row.freight)) {
            this.$set(row, "freight", (row.freight * 1).toFixed(6));
            // Total Cost(without VAT)=freight+Price per Case(wo VAT) 
            totalCost = (row.freight * 1 + row.purchaseForcast * 1).toFixed(6);
          } else {
            totalCost = (row.purchaseForcast * 1).toFixed(6);
          }
          if (commonFun.isNotEmpty(row.totalEstimatedQty)) {
            // Total Estimated Amount (RMB)=Total Estimated Qty(Case)* Total Cost(without VAT)
            totalEstimatedAmount = row.totalEstimatedQty * totalCost;
          }
        }
        materialService.getMaterialDataV2({
          eightBitCode: row.localItem
        }).then((res) => {
          console.log("🚀 ~ file: newCampaign.vue:2749 ~ setPurchaseForcast ~ res:", res)
          externalPackagingNetweight = res.resultData[0].externalPackagingNetweight
          if (commonFun.isNotEmpty(externalPackagingNetweight)) {
            // Price per UNIT(RMB EXCL.VAT)(Price)=Price per CASE(wo VAT)/产品外包装净重(kg)；
            price = ((row.purchaseForcast * 1) / (externalPackagingNetweight)).toFixed(6)
          }
          console.log("🚀 ~ file: newCampaign.vue:2654 ~ setPurchaseForcast ~ price:", price)
          this.$set(row, "pricePerUnit", price);
        });

        this.$set(row, "totalCost", totalCost);
        this.$set(row, "totalEstimatedAmount", totalEstimatedAmount);
      }
    },
    setPricePerCaseContrast(row) {
      if (commonFun.isNotEmpty(row.pricePerCaseContrast)) {
        let reg = /^\d+(\.\d+)?$/
        if (!reg.test(row.pricePerCaseContrast)) {
          this.$set(row, "pricePerCaseContrast", '');
        } else {
          this.$set(row, "pricePerCaseContrast", (row.pricePerCaseContrast * 1).toFixed(6));
        }
        let price = 0;
        if (commonFun.isNotEmpty(row.externalPackagingNetweight)) {
          // 对比物料Price per UNIT(RMB EXCL.VAT)(Price)=对比物料Price per Case(wo VAT)/产品外包装净重(kg)；
          price = ((row.pricePerCaseContrast * 1) / (row.externalPackagingNetweight)).toFixed(6)
        }
        this.$set(row, "pricePerUnitContrast", price);
      }
    },
    setPricePerUnit(row) {
      if (commonFun.isNotEmpty(row.pricePerUnit)) {
        let reg = /^\d+(\.\d+)?$/
        if (!reg.test(row.pricePerUnit)) {
          this.$set(row, "pricePerUnit", '');
        } else {
          this.$set(row, "pricePerUnit", (row.pricePerUnit * 1).toFixed(6));
        }
      }
    },
    setPricePerUnitContrast(row) {
      if (commonFun.isNotEmpty(row.pricePerUnitContrast)) {
        let reg = /^\d+(\.\d+)?$/
        if (!reg.test(row.pricePerUnitContrast)) {
          this.$set(row, "pricePerUnitContrast", '');
        } else {
          this.$set(row, "pricePerUnitContrast", (row.pricePerUnitContrast * 1).toFixed(6));
        }
      }
    },
    fpaNfsAdd(item) {
      console.log("🚀 ~ file: newCampaign.vue:1952 ~ fpaNfsAdd ~ item:", item)
      // let index = 0;
      console.log('negativeIndex1111', this.negativeIndex);
      // if (commonFun.isEmpty(this.formData.fpaLtoPqcnList)) {
      //   this.formData.fpaLtoPqcnList = [];
      // } else {
      //   let ttLtoFpaPqcnIdArr = this.formData.fpaLtoPqcnList.map(row => row.ttFpaLtoPqcnId);
      //   ttLtoFpaPqcnIdArr = ttLtoFpaPqcnIdArr.sort((a, b) => a - b);
      //   // index = parseInt(ttLtoFpaPqcnIdArr[ttLtoFpaPqcnIdArr.length - 1]);
      // }
      // let ltoFpaPqcn = {
      //   ttFpaLtoPqcnId: this.negativeIndex,
      //   localItem: '',
      //   localItemContrast: ''
      // };
      // this.formData.fpaLtoPqcnList.push(ltoFpaPqcn);
      // this.negativeIndex = this.negativeIndex - 1;
      // console.log('negativeIndex新增后', this.negativeIndex);
      this.isFirstLoad = true
      if (commonFun.isNotEmpty(this.formData.fpaLtoPqcnList)) {
        let ttLtoFpaPqcnIdArr
        this.childTabs.forEach(ele => {
          if (ele.tmUserId === item.tmUserId) {
            ttLtoFpaPqcnIdArr = ele.lists.map(row => row.ttFpaLtoPqcnId);
            ttLtoFpaPqcnIdArr = ttLtoFpaPqcnIdArr.sort((a, b) => a - b);
          }
        })
      }
      console.log(' this.selName', this.selName)
      var curTab = this.childTabs[this.selName].tmUserId
      console.log("🚀 ~ file: newCampaign.vue:2116 ~ curTab ~ curTab:", curTab)
      let ltoFpaPqcn = {
        ttFpaLtoPqcnId: this.negativeIndex,
        supplierName: null,
        plantName: null,
        dcIdList: null,
        localItem: null,
        localItemContrast: 'NA',
        ingredient: null,
        purchaseForcast: null,
        pricePerCaseContrast: null,
        vat: null,
        pricePerUnit: null,
        unit: "KG",
        pricePerUnitContrast: null,
        unitContrast: "KG",
        priceValidDateFrom: null,
        priceValidDateTo: null,
        totalEstimatedQty: null,
        totalEstimatedAmount: null,
        transportaionMethod: null,
        tradeTerm: null,
        freight: null,
        totalCost: null,
        promotionDateFrom: null,
        promotionDateTo: null,
        remark: null,
        packagingSize: null,
        packingSizePerCaseContrast: null,
        netContent: null,
        netContentContrast: null,
        nfcCategoryLeaderId: curTab,
        ssCategoryLeaderId: null,
      };
      materialService.getMaterialDataV2({
        eightBitCode: 'NA'
      }).then((res) => {
        console.log("🚀 ~ file: newCampaign.vue:2840 ~ fpaNfsAdd ~ res:", res)
        this.pickMaterial1(res.resultData[0], ltoFpaPqcn)
      });
      if (this.formData.agreementStartDate) {
        this.$set(ltoFpaPqcn, 'priceValidDateFrom', this.formData.agreementStartDate)
        this.$set(ltoFpaPqcn, 'promotionDateFrom', this.formData.agreementStartDate)
      }
      if (this.formData.agreementEndDate) {
        this.$set(ltoFpaPqcn, 'priceValidDateTo', this.formData.agreementEndDate)
        this.$set(ltoFpaPqcn, 'promotionDateTo', this.formData.agreementEndDate)
      }
      this.childTabs.forEach(ele => {
        if (ele.tmUserId === item.tmUserId) {
          ele.lists.push(ltoFpaPqcn)
        }
      })
      this.negativeIndex = this.negativeIndex - 1;
      console.log('negativeIndex新增后', this.negativeIndex);
      console.log('新增后的childTabs', this.childTabs)
      this.$forceUpdate();
    },
    //fpaPqcnList选择操作
    handleFpaLtoPqcnChange(row) {
      this.ttFpaLtoPqcnIdLists = []
      this.fpaLtoPqcnSelect = row;
      row.forEach(ele => {
        this.ttFpaLtoPqcnIdLists.push(ele.ttFpaLtoPqcnId)
      })
      console.log('ttFpaLtoPqcnIdLists', this.ttFpaLtoPqcnIdLists);
    },
    copyLine() {
      let that = this;
      // const rows = this.$refs.fpaLtoPqcnList.selection;
      let copyRows = {};
      console.log('选中的行项目', this.fpaLtoPqcnSelect);
      console.log('negativeIndex', this.negativeIndex);
      var obj = this.childTabs.filter(ele => {
        return ele.tmUserId == this.ms_userId
      })
      obj[0].lists.forEach((row, index) => {
        this.fpaLtoPqcnSelect.forEach(copyRow => {
          if (copyRow === row) {
            copyRows[index] = commonFun.deepCopy(row);
            // copyRows.ttFpaLtoPqcnId = this.negativeIndex
          }
        })
      })
      let keys = Object.keys(copyRows);
      console.log('copyRows', copyRows);
      console.log('keys', keys);
      let totalCost = 0;
      let totalEstimatedAmount = 0;
      keys.forEach(index => {
        copyRows[index].ttFpaLtoPqcnId = this.negativeIndex
        this.negativeIndex = this.negativeIndex - 1;
        this.childTabs[this.selName].lists.splice(index + 1, 0, copyRows[index]);
        // that.formData.fpaLtoPqcnList.splice(index + 1, 0, copyRows[index]);
      });
      console.log('231231', this.childTabs)

      var ref = 'childLists' + this.selName
      console.log("🚀 ~ file: newCampaign.vue:2142 ~ copyLine ~ ref:", ref)
      console.log("🚀 ~ file: newCampaign.vue:2144 ~ copyLine ~ this.$refs[ref]:", this.$refs[ref])
      this.$refs[ref][0].clearSelection();
      console.log('negativeIndex复制后', this.negativeIndex);
    },
    handleClick(val) {
      console.log('当前tab', val);
      this.selName = val.name
      this.tabIndex = val.label
      console.log("🚀 ~ file: newCampaign.vue:2147 ~ handleClick ~ this.selName:", this.selName)
    },
    fpaNfsDel() {
      console.log('ttFpaLtoPqcnIdLists', this.ttFpaLtoPqcnIdLists);
      console.log('fpaLtoPqcnSelect', this.fpaLtoPqcnSelect);
      console.log('fpaLtoPqcnList', this.formData.fpaLtoPqcnList);
      let that = this;
      var arr = that.formData.fpaLtoPqcnList
      if (that.ttFpaLtoPqcnIdLists.length == 0) {
        //请选择需要删除的记录！
        // this.$message.error(this.$t('fpaManage.permanent.pleaseChooseToDelete'))
        this.$msg.error(this.$t('fpaManage.permanent.pleaseChooseToDelete'))
        return false;
      }
      //您确定要删除所选记录吗？
      that.$confirm('Are you sure to delete these records?', 'Tips', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        customClass: 'colorBtn',
        cancelButtonClass: 'btn_custom_cancel',
        type: 'warning'
      }).then(() => {
        console.log('this.selName', this.selName)
        var obj = this.childTabs.filter(ele => {
          return ele.tmUserId == this.ms_userId
        })
        console.log("🚀 ~ file: newCampaign.vue:2165 ~ obj ~ obj:", obj)
        var length = obj[0].lists.length
        for (let i = length - 1; i >= 0; i--) {
          const element = obj[0].lists[i];
          console.log("🚀 ~ file: newCampaign.vue:2169 ~ fpaNfsDel ~ element:", element)
          if (this.ttFpaLtoPqcnIdLists.includes(element.ttFpaLtoPqcnId)) {
            this.childTabs[this.selName].lists.splice(i, 1);
          }
        }
        console.log("🚀 ~ file: newCampaign.vue:2160 ~ fpaNfsDel ~ this.childTabs:", this.childTabs)
        this.$forceUpdate();
      })

    },
    // localItemBlur(materialNo, row) {
    //   if (commonFun.isNotEmpty(materialNo)) {
    //     this.$set(row, 'localItem', materialNo);
    //   }
    // var obj = this.childTabs.filter(ele => {
    //   return ele.tmUserId == this.ms_userId
    // })
    // obj[0].lists.forEach((allVal, index) => {
    //   if (row.ttFpaLtoPqcnId != allVal.ttFpaLtoPqcnId && allVal.localItem == row.localItem) {
    //     //重复的物料编号!
    //     this.$message.error(this.$t('fpaManage.ltoCampaign.localItemExists'))
    //     this.$set(row, 'localItem', null);
    //   }
    // });
    // },
    pickMaterial(material, index, row) {
      console.log("🚀 ~ file: newCampaign.vue:2076 ~ pickMaterial ~ row:", row)
      console.log("🚀 ~ file: newCampaign.vue:2076 ~ pickMaterial ~ material:", material)
      console.log("🚀 ~ 计量单位:", this.unitLists)
      console.log("🚀 ~ 产品内包装类型:", this.innerPackingTypeLists)
      console.log("🚀 ~ 产品外包装类型:", this.productPackagingTypeLists)
      if (commonFun.isNotEmpty(material) && commonFun.isNotEmpty(material.eightBitCode)) {
        console.log('进来了')
        this.$set(row, 'supplierName', material.supplierName);
        this.$set(row, 'supplierCode', material.supplierCode);
        this.$set(row, 'plantName', material.plantName);
        this.$set(row, 'plantNo', material.plantNo);
        if (material.dcs) {
          this.$set(row, 'dcIdList', material.dcs.split(','));
        }
        this.$set(row, 'ingredient', material.eightBitCodeName);//供应物料 Ingredient
        this.$set(row, 'purchaseForcast', material.exFactoryExcUnitPrice);//Price per Case(wo VAT)
        this.$set(row, 'tradeTerm', material.priceType);//Trade Term
        this.$set(row, 'vat', material.urchaseTaxRate);//VAT

        this.$set(row, 'quantityUomOutsourceNum', material.quantityUomOutsourceNum);//外包装内含UOM数量
        this.$set(row, ' externalPackagingNetweight', material.externalPackagingNetweight);//产品外包装净重:
        this.$set(row, 'outerPackageContainsNum', material.outerPackageContainsNum);//外包装内含内包装数量:
        this.$set(row, 'quantityUomInnerNum', material.quantityUomInnerNum);//内包装内含UOM数量:
        this.$set(row, 'tmSupplierId', material.supperSupplierId);
        console.log('判断是否有内包装', material.isInnerPacking)
        var innerPackingType
        var griUom
        var type2
        var arr1 = this.unitLists.filter(ele => {
          return material.griUom === ele.code
        })
        console.log("找到对应的计量单位数组是:", arr1)
        if (arr1.length > 0) {
          griUom = arr1[0].chineseValue
        }
        console.log("对应的计量单位值是:", griUom)
        if (material.isInnerPacking == 'Y') {
          var arr = this.innerPackingTypeLists.filter(ele => {
            return material.innerPackingType == ele.code
          })
          console.log("找到对应的产品内包装类型数组是:", arr)
          if (arr.length > 0) {
            innerPackingType = arr[0].chineseValue
          }
          console.log("对应的产品内包装类型值是:", innerPackingType)
          // 如果是否有内包装为是，则外包装内含内包装数量（产品内包装类型）*内包装内含UOM数量（计量单位），带出结果示例1包(Bag)*10升；
          if (!material.outerPackageContainsNum && !material.quantityUomInnerNum) {
            this.$set(row, 'packagingSize', null)
            if (material.externalPackagingNetweight) {
              this.$set(row, 'netContent', material.externalPackagingNetweight + 'KG');
            } else {
              this.$set(row, 'netContent', null);
            }
          } else if (material.outerPackageContainsNum && !material.quantityUomInnerNum) {
            if (innerPackingType) {
              this.$set(row, 'packagingSize', material.outerPackageContainsNum + innerPackingType + '*');
            } else {
              this.$set(row, 'packagingSize', material.outerPackageContainsNum + '*');
            }
            if (material.externalPackagingNetweight) {
              this.$set(row, 'netContent', material.externalPackagingNetweight + 'KG');
            } else {
              this.$set(row, 'netContent', null);
            }
          } else if (!material.outerPackageContainsNum && material.quantityUomInnerNum) {
            if (griUom) {
              this.$set(row, 'packagingSize', '*' + material.quantityUomInnerNum + griUom);
              if (griUom == '千克') {
                if (material.externalPackagingNetweight) {
                  this.$set(row, 'netContent', material.externalPackagingNetweight + 'KG');
                } else {
                  this.$set(row, 'netContent', null);
                }
              } else {
                if (material.externalPackagingNetweight) {
                  this.$set(row, 'netContent', material.quantityUomInnerNum + griUom + ' or ' + material.externalPackagingNetweight + 'KG');
                } else {
                  this.$set(row, 'netContent', material.quantityUomInnerNum + griUom);
                }
              }
            } else {
              this.$set(row, 'packagingSize', '*' + material.quantityUomInnerNum);
              if (material.externalPackagingNetweight) {
                this.$set(row, 'netContent', material.quantityUomInnerNum + ' or ' + material.externalPackagingNetweight + 'KG');
              } else {
                this.$set(row, 'netContent', material.quantityUomInnerNum);
              }
            }
          } else {
            var num1, num2
            if (innerPackingType) {
              num1 = material.outerPackageContainsNum + innerPackingType
            } else {
              num1 = material.outerPackageContainsNum
            }
            if (griUom) {
              num2 = material.quantityUomInnerNum + griUom
              if (griUom == '千克') {
                if (material.externalPackagingNetweight) {
                  this.$set(row, 'netContent', material.externalPackagingNetweight + 'KG');
                } else {
                  this.$set(row, 'netContent', null);
                }
              } else {
                if (material.externalPackagingNetweight) {
                  this.$set(row, 'netContent', material.quantityUomInnerNum + griUom + ' or ' + material.externalPackagingNetweight + 'KG');
                } else {
                  this.$set(row, 'netContent', material.quantityUomInnerNum + griUom);
                }
              }
            } else {
              num2 = material.quantityUomInnerNum
              if (material.externalPackagingNetweight) {
                this.$set(row, 'netContent', material.quantityUomInnerNum + 'or' + material.externalPackagingNetweight + 'KG');
              } else {
                this.$set(row, 'netContent', material.quantityUomInnerNum);
              }
            }
            this.$set(row, 'packagingSize', num1 + '*' + num2);
          }
        } else {
          // 如果是否有内包装为否，则1(产品外包装类型)* 外包装内含UOM数量(计量单位)
          var arr = this.productPackagingTypeLists.filter(ele => {
            return material.productPackagingType === ele.code
          })
          console.log("对应的产品外包装类型值是:", arr)
          if (arr.length > 0) {
            type2 = arr[0].chineseValue
          }
          if (!material.quantityUomOutsourceNum) {
            var num1
            if (type2) {
              num1 = '1' + type2
            } else {
              num1 = '1'
            }
            if (material.externalPackagingNetweight) {
              this.$set(row, 'netContent', material.externalPackagingNetweight + 'KG');
            } else {
              this.$set(row, 'netContent', null);
            }
            this.$set(row, 'packagingSize', num1 + '*');
          } else {
            var num1, num2
            if (type2) {
              num1 = '1' + type2
            } else {
              num1 = '1'
            }
            if (griUom) {
              num2 = material.quantityUomOutsourceNum + griUom
              if (griUom == '千克') {
                if (material.externalPackagingNetweight) {
                  this.$set(row, 'netContent', material.externalPackagingNetweight + 'KG');
                } else {
                  this.$set(row, 'netContent', null);
                }
              } else {
                if (material.externalPackagingNetweight) {
                  this.$set(row, 'netContent', material.quantityUomOutsourceNum + griUom + ' or ' + material.externalPackagingNetweight + 'KG');
                } else {
                  this.$set(row, 'netContent', material.quantityUomOutsourceNum + griUom);
                }
              }
            } else {
              num2 = material.quantityUomOutsourceNum
              if (material.externalPackagingNetweight) {
                this.$set(row, 'netContent', material.quantityUomOutsourceNum + 'or' + material.externalPackagingNetweight + 'KG');
              } else {
                this.$set(row, 'netContent', material.quantityUomOutsourceNum);
              }
            }
            this.$set(row, 'packagingSize', num1 + '*' + num2);
          }
        }


        let totalCost = 0;
        let totalEstimatedAmount = 0;
        if (commonFun.isNotEmpty(material.exFactoryExcUnitPrice)) {
          if (commonFun.isNotEmpty(row.freight)) {
            this.$set(row, "freight", (row.freight * 1).toFixed(6));
            // Total Cost(without VAT)=freight+Price per Case(wo VAT) 
            totalCost = (row.freight * 1 + material.exFactoryExcUnitPrice * 1).toFixed(6);
          } else {
            totalCost = (material.exFactoryExcUnitPrice * 1).toFixed(6);
          }
          if (commonFun.isNotEmpty(row.totalEstimatedQty)) {
            // Total Estimated Amount (RMB)=Total Estimated Qty(Case)* Total Cost(without VAT)
            totalEstimatedAmount = row.totalEstimatedQty * totalCost;
          }
        }
        var num = 0
        if (commonFun.isNotEmpty(material.exFactoryExcUnitPrice) && commonFun.isNotEmpty(material.externalPackagingNetweight)) {
          // Price per UNIT(RMB EXCL.VAT)(Price)=Price per CASE(wo VAT)/产品外包装净重(kg)；
          num = (material.exFactoryExcUnitPrice / material.externalPackagingNetweight).toFixed(6)
          this.$set(row, 'pricePerUnit', num)
        }
        this.$set(row, "totalCost", totalCost);
        this.$set(row, "totalEstimatedAmount", totalEstimatedAmount);
        console.log('选择', this.childTabs)
      }
    },
    pickMaterial1(material, row) {
      console.log("🚀 ~ file: newCampaign.vue:2108 ~ pickMaterial1 ~ row:", row)
      console.log("🚀 ~ file: newCampaign.vue:2108 ~ pickMaterial1 ~ material:", material)
      if (commonFun.isNotEmpty(material) && commonFun.isNotEmpty(material.eightBitCode)) {
        this.$set(row, 'ingredientContrast', material.eightBitCodeName);//对比物料 Ingredient
        this.$set(row, 'pricePerCaseContrast', material.exFactoryExcUnitPrice);//对比物料Price per Case(wo VAT)
        this.$set(row, 'quantityUomOutsourceNum', material.quantityUomOutsourceNum);//外包装内含UOM数量
        this.$set(row, ' externalPackagingNetweight', material.externalPackagingNetweight);//产品外包装净重:
        this.$set(row, 'outerPackageContainsNum', material.outerPackageContainsNum);//外包装内含内包装数量:
        this.$set(row, 'quantityUomInnerNum', material.quantityUomInnerNum);//内包装内含UOM数量:
        var innerPackingType
        var griUom
        var type2
        var arr1 = this.unitLists.filter(ele => {
          return material.griUom === ele.code
        })
        console.log("对应的计量单位值是:", arr1)
        if (arr1.length > 0) {
          griUom = arr1[0].chineseValue
        }
        if (material.isInnerPacking === 'Y') {
          var arr = this.innerPackingTypeLists.filter(ele => {
            return material.innerPackingType === ele.code
          })
          console.log("对应的产品内包装类型值是:", arr)
          if (arr.length > 0) {
            innerPackingType = arr[0].chineseValue
          }
          // 如果是否有内包装为是，则外包装内含内包装数量（产品内包装类型）*内包装内含UOM数量（计量单位），带出结果示例1包(Bag)*10升；
          if (!material.outerPackageContainsNum && !material.quantityUomInnerNum) {
            this.$set(row, 'packingSizePerCaseContrast', null)
            if (material.externalPackagingNetweight) {
              this.$set(row, 'netContentContrast', material.externalPackagingNetweight + 'KG');
            } else {
              this.$set(row, 'netContentContrast', null);
            }
          } else if (material.outerPackageContainsNum && !material.quantityUomInnerNum) {
            if (innerPackingType) {
              this.$set(row, 'packingSizePerCaseContrast', material.outerPackageContainsNum + innerPackingType + '*');
            } else {
              this.$set(row, 'packingSizePerCaseContrast', material.outerPackageContainsNum + '*');
            }
            if (material.externalPackagingNetweight) {
              this.$set(row, 'netContentContrast', material.externalPackagingNetweight + 'KG');
            } else {
              this.$set(row, 'netContentContrast', null);
            }
          } else if (!material.outerPackageContainsNum && material.quantityUomInnerNum) {
            if (griUom) {
              this.$set(row, 'packingSizePerCaseContrast', '*' + material.quantityUomInnerNum + griUom);
              if (griUom == '千克') {
                if (material.externalPackagingNetweight) {
                  this.$set(row, 'netContentContrast', material.externalPackagingNetweight + 'KG');
                } else {
                  this.$set(row, 'netContentContrast', null);
                }
              } else {
                if (material.externalPackagingNetweight) {
                  this.$set(row, 'netContentContrast', material.quantityUomInnerNum + griUom + ' or ' + material.externalPackagingNetweight + 'KG');
                } else {
                  this.$set(row, 'netContentContrast', material.quantityUomInnerNum + griUom);
                }
              }
            } else {
              this.$set(row, 'packingSizePerCaseContrast', '*' + material.quantityUomInnerNum);
              if (material.externalPackagingNetweight) {
                this.$set(row, 'netContentContrast', material.quantityUomInnerNum + ' or ' + material.externalPackagingNetweight + 'KG');
              } else {
                this.$set(row, 'netContentContrast', material.quantityUomInnerNum);
              }
            }
          } else {
            var num1, num2
            if (innerPackingType) {
              num1 = material.outerPackageContainsNum + innerPackingType
            } else {
              num1 = material.outerPackageContainsNum
            }
            if (griUom) {
              num2 = material.quantityUomInnerNum + griUom
              if (griUom == '千克') {
                if (material.externalPackagingNetweight) {
                  this.$set(row, 'netContentContrast', material.externalPackagingNetweight + 'KG');
                } else {
                  this.$set(row, 'netContentContrast', null);
                }
              } else {
                if (material.externalPackagingNetweight) {
                  this.$set(row, 'netContentContrast', material.quantityUomInnerNum + griUom + ' or ' + material.externalPackagingNetweight + 'KG');
                } else {
                  this.$set(row, 'netContentContrast', material.quantityUomInnerNum + griUom);
                }
              }
            } else {
              num2 = material.quantityUomInnerNum
              if (material.externalPackagingNetweight) {
                this.$set(row, 'netContentContrast', material.quantityUomInnerNum + 'or' + material.externalPackagingNetweight + 'KG');
              } else {
                this.$set(row, 'netContentContrast', material.quantityUomInnerNum);
              }
            }
            this.$set(row, 'packingSizePerCaseContrast', num1 + '*' + num2);
          }
          if (material.eightBitCode == 'NA') {
            this.$set(row, 'packingSizePerCaseContrast', null)
          }
        } else {
          // 如果是否有内包装为否，则1(产品外包装类型)* 外包装内含UOM数量(计量单位)
          var arr = this.productPackagingTypeLists.filter(ele => {
            return material.productPackagingType === ele.code
          })
          console.log("对应的产品外包装类型值是:", arr)
          if (arr.length > 0) {
            type2 = arr[0].chineseValue
          }
          if (!material.quantityUomOutsourceNum) {
            var num1
            if (type2) {
              num1 = '1' + type2
            } else {
              num1 = '1'
            }
            if (material.externalPackagingNetweight) {
              this.$set(row, 'netContentContrast', material.externalPackagingNetweight + 'KG');
            } else {
              this.$set(row, 'netContentContrast', null);
            }
            this.$set(row, 'packingSizePerCaseContrast', num1 + '*');
          } else {
            var num1, num2
            if (type2) {
              num1 = '1' + type2
            } else {
              num1 = '1'
            }
            if (griUom) {
              num2 = material.quantityUomOutsourceNum + griUom
              if (griUom == '千克') {
                if (material.externalPackagingNetweight) {
                  this.$set(row, 'netContentContrast', material.externalPackagingNetweight + 'KG');
                } else {
                  this.$set(row, 'netContentContrast', null);
                }
              } else {
                if (material.externalPackagingNetweight) {
                  this.$set(row, 'netContentContrast', material.quantityUomOutsourceNum + griUom + ' or ' + material.externalPackagingNetweight + 'KG');
                } else {
                  this.$set(row, 'netContentContrast', material.quantityUomOutsourceNum + griUom);
                }
              }
            } else {
              num2 = material.quantityUomOutsourceNum
              if (material.externalPackagingNetweight) {
                this.$set(row, 'netContentContrast', material.quantityUomOutsourceNum + 'or' + material.externalPackagingNetweight + 'KG');
              } else {
                this.$set(row, 'netContentContrast', material.quantityUomOutsourceNum);
              }
            }
            this.$set(row, 'packingSizePerCaseContrast', num1 + '*' + num2);
          }
          if (material.eightBitCode == 'NA') {
            this.$set(row, 'packingSizePerCaseContrast', null)
          }
        }
        let price = 0;
        if (commonFun.isNotEmpty(material.exFactoryExcUnitPrice) && commonFun.isNotEmpty(material.externalPackagingNetweight)) {
          // 对比物料Price per UNIT(RMB EXCL.VAT)(Price)=对比物料Price per Case(wo VAT)/产品外包装净重(kg)
          price = ((material.exFactoryExcUnitPrice * 1) / (material.externalPackagingNetweight)).toFixed(6)
        }
        this.$set(row, "pricePerUnitContrast", price);
        if (material.supperSupplierId) {
          this.$set(row, 'isValid', 'Y');
        } else {
          this.$set(row, 'isValid', 'N');
        }
        // }
      }
    },
    fpaNfsDownload() {
      let data = commonFun.deepCopy(this.formData);
      if (this.formData.status != 'new') {
        data.fpaLtoPqcnList = data.fpaLtoPqcnList.filter(pqcn => pqcn.isLocal == 1);
      } else {
        var obj = this.childTabs.filter(ele => {
          return ele.tmUserId == this.ms_userId
        })
        data.fpaLtoPqcnList = obj[0].lists
      }
      fpaLtoCampaignApi.fpaLtoNfsDownload(data).then((res) => {
        if (this.formData.status != 'new') {
          if (this.$refs.upload) {
            this.$refs.upload.clearFiles();
          }
        } else {
          var ref = 'upload' + this.selName
          if (this.$refs[ref][0]) {
            this.$refs[ref][0].clearFiles();
          }
        }
        if (res.data) {
          fileService.respToFile(res, 'FPA_LTO.xls')
        } else {
          // this.$message.error(res.msg || this.$t("common.operateError"));
          this.$msg.error(res.msg || this.$t("common.operateError"))
        }
      });
    },
    fpaNfsAllDownload() {
      let data = commonFun.deepCopy(this.formData);
      if (this.formData.status != 'new') {
        data.fpaLtoPqcnList = data.fpaLtoPqcnList.filter(pqcn => pqcn.isLocal == 1);
      } else {
        data.fpaLtoPqcnList = this.formData.fpaLtoPqcnList
      }
      fpaLtoCampaignApi.fpaLtoNfsDownload(data).then((res) => {
        if (res.data) {
          fileService.respToFile(res, 'FPA_LTO.xls')
        } else {
          this.$msg.error(res.msg || this.$t("common.operateError"))
        }
      });
    },
    checkData(row, index) {
      var str = [
        {
          prop: this.formData.productOrCommodityPurchased,
          label: "Product or Commodity Purchased",
          format: ['validLengthThousand']
        },
        {
          prop: this.formData.riskIdentifiHedgeJustifi,
          label: "Risk Identification & Hedge Justification",
          format: ['validLengthThousand']
        },
      ]
      const h = this.$createElement
      var valid = this.utils.centralizedValid(str, h)
      console.log('校验结果', valid);
      if (!valid) {
        return false
      }
      let errorMsg = '';
      this.formData.fpaLtoPqcnList.forEach(pqcn => {
        if (pqcn.isLocal == '1' && !pqcn.totalEstimatedAmount) {
          errorMsg += pqcn.localItem + ',';
          return false;
        }
      });
      if (errorMsg) {
        //没有维护totalEstimatedAmount
        // this.$message.error(errorMsg.slice(0, errorMsg.length - 1) + this.$t('fpaManage.ltoCampaign.totalEstimatedAmountCheck'))
        this.$msg.error(errorMsg.slice(0, errorMsg.length - 1) + this.$t('fpaManage.ltoCampaign.totalEstimatedAmountCheck'))
        return false;
      }
      return true;
    },
    localItemAttachmentUpload(ttFpaLtoId) {
      this.localItemShowFileUpload = true;
      this.ttFpaLtoId = ttFpaLtoId;
    },
    handleInput(value, field) {
      let formattedValue = value.replace(/[^\d]/g, '');
      if (formattedValue && formattedValue.startsWith('0')) {
        formattedValue = parseInt(formattedValue, 10);
      }
      this.formData[field] = formattedValue;
    },
    routerBack() {
      this.$router.back();
      //this.$root.eventHub.$emit("onSelectItem", '/sorManage');
    },
  },
  extends: commonFunction
};
</script>
<style lang="scss" scoped>
.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  display: inline-block;
}
.el-form-item.is-required:not(.is-no-asterisk)
  .el-form-item__label-wrap
  > .el-form-item__label:after,
.el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:after {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}
// 整体内容
.fpaDetail {
  width: calc(100% - 20px);
  padding: 10px;
  background-color: #fff;
}
// 第一行只可view
.view_content {
  height: 50px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.35);
  border-radius: 6px;
  margin-top: 10px;
  display: flex;
  align-content: center;
  justify-content: space-between;
  .fpaNo,
  .status,
  .creator,
  .createDate {
    width: 20%;
    height: 40px;
    padding: 5px 0;
    text-align: center;
    border-right: 1px solid #ddd;
    p {
      height: 20px;
      line-height: 20px;
    }
  }
  .approver {
    width: 20%;
    height: 40px;
    padding: 5px 0;
    text-align: center;
    p {
      height: 20px;
      line-height: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
// 第二行整体
.info_box_father {
  width: 100%;
  background-color: #fff;
}
.info_box {
  width: 100%;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}
.info_box_lf {
  width: 60%;
}
.info_box_lf,
.info_box_rg {
  border-radius: 6px;
  padding: 0 10px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.35);
}
// Basic Information
// Notional  Value of Agreement
.info_box_rg {
  width: 38%;
  margin-left: 20px;
  .national_box {
    .price_box1 {
      width: 80%;
      height: 100px;
      font-size: 34px;
      margin: 0 auto;
      color: #f8ab01;
      display: flex;
      flex-direction: row;
      align-items: center;
      border: 1px dashed #f8ab01;
      .qian {
        margin: 0 30px 0 50px;
      }
      .notional_qian {
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: 100px;
        line-height: 100px;
      }
    }
  }
}
// 模块的标题
.info_box_title {
  height: 30px;
  margin-top: 10px !important;
}
.info_title {
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  font-weight: bold;
  margin-left: 5px;
  float: left;
}
.line {
  width: 3px;
  height: 16px;
  margin: 7px 0;
  background-color: #f8ab01;
  float: left;
}
.label_icon {
  display: inline-block;
  height: 32px;
  line-height: 32px;
  margin-right: 10px;
}
.el-icon-date:before,
.el-icon-menu:before,
.el-icon-notebook-2:before,
.el-icon-user-solid:before,
.el-icon-s-marketing:before {
  font-size: 22px;
  vertical-align: middle;
  color: #7f7f7f;
}
.el-icon-coin:before {
  font-size: 22px;
  color: #7f7f7f;
  vertical-align: middle;
}
.btn {
  width: 100%;
  height: 50px;
  padding: 0 20px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.35);
  border-radius: 6px;
}
.notionalValueOfAgreement1 {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.totalForm {
  height: 33px;
  margin-bottom: 18px;
}
.price_info,
.cost_analysis {
  background-color: #fff;
  margin-top: 10px;
  border-radius: 6px;
  padding: 0 10px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.35);
}
.tab_box {
  background-color: #fff;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.35);
  padding: 10px;
  margin-top: 10px;
  border-radius: 6px;
}
.table-d {
  border-collapse: collapse;
  margin-bottom: 12px;
  font-size: 12px;
  width: 100%;
  .el-form-item--mini.el-form-item,
  .el-form-item--small.el-form-item {
    margin-bottom: 0px !important;
  }
}
.table-d td {
  border: 1px solid #ebeef5;
  text-align: center;
  padding: 9px 10px 10px;
  width: 23%;
}
.table-d .title {
  background: #fafafa;
}
.coverage_box {
  margin-top: 30px;
}
</style>